(function () {
  const CUSTOMIZATION_VERSION = "text-only-optional-v38-pixel-name-right";
  const DEFAULT_TEXT_SAMPLE = "SA";
  const DEFAULT_TEXT_COLOR = "#E7087F";
  const DEFAULT_TEXT_SIZE = 55;
  const DEFAULT_FRAME_BORDER_COLOR = "#B29345";
  const DEFAULT_FRAME_FILL_COLOR = "#FFFFFF";
  const FIXED_FRAME_SIZES = {
    oval: {
      widthRatio: 0.54,
      heightRatio: 0.22,
    },
    round: {
      widthRatio: 0.3,
      heightRatio: 0.3,
    },
    label: {
      widthRatio: 0.5,
      heightRatio: 0.16,
    },
  };
  const TEXT_FONT_PRESETS = {
    "classic-serif": {
      family: '"Playfair Display", "Georgia", "Times New Roman", serif',
      weight: "600",
      lineHeight: 1.06,
      letterSpacing: 0.01,
    },
    "modern-sans": {
      family: '"Montserrat", "Helvetica Neue", Arial, sans-serif',
      weight: "600",
      lineHeight: 1.04,
      letterSpacing: 0.01,
    },
    "signature-script": {
      family: '"Great Vibes", "Brush Script MT", "Segoe Script", cursive',
      weight: "400",
      sizeMultiplier: 1.08,
      canvasYOffset: 0.03,
      lineHeight: 0.98,
      letterSpacing: 0.005,
    },
    "elegant-script": {
      family: '"Allura", "Segoe Script", cursive',
      weight: "400",
      sizeMultiplier: 1.04,
      canvasYOffset: 0.025,
      lineHeight: 0.98,
      letterSpacing: 0.004,
    },
    "romantic-script": {
      family: '"Parisienne", "Brush Script MT", cursive',
      weight: "400",
      sizeMultiplier: 1.05,
      canvasYOffset: 0.022,
      lineHeight: 0.98,
      letterSpacing: 0.004,
    },
    "natural-handwriting": {
      family: '"Kalam", "Segoe Print", cursive',
      weight: "400",
      lineHeight: 1.08,
      letterSpacing: 0,
    },
    monogram: {
      family: '"Cinzel", "Palatino Linotype", "Book Antiqua", serif',
      weight: "700",
      lineHeight: 1.02,
      letterSpacing: 0.08,
    },
    "modern-serif": {
      family: '"Cormorant Garamond", "Georgia", serif',
      weight: "700",
      lineHeight: 1.04,
      letterSpacing: 0.018,
    },
    "soft-rounded": {
      family: '"Quicksand", "Trebuchet MS", "Arial Rounded MT Bold", sans-serif',
      weight: "600",
      lineHeight: 1.04,
      letterSpacing: 0.008,
    },
  };
  const TEXT_ANCHOR_PRESETS = {
    bottom: {
      textAlign: "center",
      alignItems: "center",
      x: 0.5,
      y: 0.75,
    },
    center: {
      textAlign: "center",
      alignItems: "center",
      x: 0.5,
      y: 0.5,
    },
  };
  const FRAME_POSITION_PRESETS = {
    center: {
      textAlign: "center",
      alignItems: "center",
      x: 0.5,
      y: 0.5,
    },
    bottom: {
      textAlign: "center",
      alignItems: "center",
      x: 0.5,
      y: 0.75,
    },
  };

  const HOLDER_DEFAULT_TEXT_SIZE = 33;
  const PIXEL_DEFAULT_TEXT_SIZE = 30;
  const HOLDER_NAME_ANCHOR = {textAlign: "center", alignItems: "center", x: 0.45, y: 0.8};
  const PIXEL_NAME_ANCHOR = {textAlign: "center", alignItems: "center", x: 0.5, y: 0.82};
  const PIXEL_SURFACES = {
    1: {width: 1254, height: 1254, corners: [[202, 45], [689, 57], [1017, 1161], [474, 1234]], nameAnchor: {...PIXEL_NAME_ANCHOR, x: 0.55}},
    2: {width: 2500, height: 3000, corners: [[1590, 615], [2540, 1098], [925, 2480], [20, 1880]]},
    // Five-view artwork uses the same 1000 x 2000 physical back plane.
    3: {width: 1254, height: 1254, planeHeight: 1000, corners: [[365, 77], [893, 77], [893, 1175], [365, 1175]]},
    4: {width: 1254, height: 1254, planeHeight: 1000, corners: [[710, 291], [1202, 387], [639, 1022], [58, 811]]},
    5: {width: 1254, height: 1254, planeHeight: 1000, corners: [[33, 568], [334, 499], [1240, 603], [901, 708]]},
    // Calibrated against the rendered standing photo: stripe vanishing point
    // (-1059.563, -5087.745), top back edge, and lower back edge.
    // The source PSD adapter quad does not describe the final warped surface.
    6: {width: 1254, height: 1254, planeHeight: 1000, corners: [[183.873, 39.744], [646.199, 54.313], [1010, 1151], [473, 1232]], nameAnchor: {...PIXEL_NAME_ANCHOR, x: 0.54}},
    // The flat template is center-cropped from 2500 x 3000, then resized to 1254 square.
    7: {width: 1254, height: 1254, planeHeight: 1000, corners: [[808.83, 193.116], [1233.936, 412.566], [476.52, 1073.424], [51.414, 802.56]]},
  };

  const HOLDER_SURFACES = {
    1: {width: 1254, height: 1254, corners: [[274, 162], [929, 180.5], [929, 1192.5], [254, 1115.5]]},
    2: {width: 1148, height: 1370, corners: [[151, 487], [620, 500], [584, 1300], [108, 1267]]},
    3: {width: 1254, height: 1254, corners: [[382, 371], [829, 386], [824, 1080], [366, 1038]]},
    4: {width: 1254, height: 1254, corners: [[447, 491], [793, 493], [786, 1063], [450, 1053]]},
    5: {width: 1254, height: 1254, corners: [[128, 329], [726, 214], [1202, 654], [438, 904]]},
  };

  function surfaceHomography(from, to) {
    const rows = [];
    for (let index = 0; index < 4; index += 1) {
      const [x, y] = from[index];
      const [u, v] = to[index];
      rows.push([x, y, 1, 0, 0, 0, -u * x, -u * y, u]);
      rows.push([0, 0, 0, x, y, 1, -v * x, -v * y, v]);
    }
    for (let column = 0; column < 8; column += 1) {
      let pivot = column;
      for (let row = column + 1; row < 8; row += 1) {
        if (Math.abs(rows[row][column]) > Math.abs(rows[pivot][column])) pivot = row;
      }
      [rows[column], rows[pivot]] = [rows[pivot], rows[column]];
      const divisor = rows[column][column];
      if (Math.abs(divisor) < 1e-10) return null;
      for (let entry = column; entry <= 8; entry += 1) rows[column][entry] /= divisor;
      for (let row = 0; row < 8; row += 1) {
        if (row === column) continue;
        const factor = rows[row][column];
        for (let entry = column; entry <= 8; entry += 1) rows[row][entry] -= factor * rows[column][entry];
      }
    }
    return [...rows.map((row) => row[8]), 1];
  }

  function projectSurfacePoint(matrix, x, y) {
    const denominator = matrix[6] * x + matrix[7] * y + matrix[8];
    return {
      x: (matrix[0] * x + matrix[1] * y + matrix[2]) / denominator,
      y: (matrix[3] * x + matrix[4] * y + matrix[5]) / denominator,
    };
  }

  function surfaceCssMatrix(matrix) {
    return `matrix3d(${[matrix[0], matrix[3], 0, matrix[6], matrix[1], matrix[4], 0, matrix[7],
      0, 0, 1, 0, matrix[2], matrix[5], 0, matrix[8]].join(',')})`;
  }

  function drawSurfaceCanvas(context, layer, corners, targetRect) {
    const from = [[0, 0], [layer.width, 0], [layer.width, layer.height], [0, layer.height]];
    const inverse = surfaceHomography(corners, from);
    if (!inverse) return;
    const sourcePixels = layer.getContext('2d').getImageData(0, 0, layer.width, layer.height).data;
    const raster = document.createElement('canvas');
    raster.width = Math.ceil(targetRect.x + targetRect.width);
    raster.height = Math.ceil(targetRect.y + targetRect.height);
    const rasterContext = raster.getContext('2d');
    const pixels = rasterContext.createImageData(raster.width, raster.height);
    const left = Math.max(0, Math.floor(Math.min(...corners.map((point) => point[0]))));
    const top = Math.max(0, Math.floor(Math.min(...corners.map((point) => point[1]))));
    const right = Math.min(raster.width, Math.ceil(Math.max(...corners.map((point) => point[0]))));
    const bottom = Math.min(raster.height, Math.ceil(Math.max(...corners.map((point) => point[1]))));
    for (let y = top; y < bottom; y += 1) {
      for (let x = left; x < right; x += 1) {
        const point = projectSurfacePoint(inverse, x + 0.5, y + 0.5);
        const sx = point.x - 0.5;
        const sy = point.y - 0.5;
        if (sx < 0 || sy < 0 || sx >= layer.width - 1 || sy >= layer.height - 1) continue;
        const ix = Math.floor(sx);
        const iy = Math.floor(sy);
        const fx = sx - ix;
        const fy = sy - iy;
        const indices = [(iy * layer.width + ix) * 4, (iy * layer.width + ix + 1) * 4,
          ((iy + 1) * layer.width + ix) * 4, ((iy + 1) * layer.width + ix + 1) * 4];
        const weights = [(1 - fx) * (1 - fy), fx * (1 - fy), (1 - fx) * fy, fx * fy];
        let alpha = 0;
        let red = 0;
        let green = 0;
        let blue = 0;
        for (let sample = 0; sample < 4; sample += 1) {
          const offset = indices[sample];
          const weight = weights[sample] * sourcePixels[offset + 3];
          alpha += weight;
          red += sourcePixels[offset] * weight;
          green += sourcePixels[offset + 1] * weight;
          blue += sourcePixels[offset + 2] * weight;
        }
        if (alpha < 0.5) continue;
        const offset = (y * raster.width + x) * 4;
        pixels.data[offset] = red / alpha;
        pixels.data[offset + 1] = green / alpha;
        pixels.data[offset + 2] = blue / alpha;
        pixels.data[offset + 3] = alpha;
      }
    }
    rasterContext.putImageData(pixels, 0, 0);
    context.drawImage(raster, 0, 0);
  }

  class ProductTextPersonalizer {
    constructor(root) {
      this.root = root;
      root.querySelectorAll("[data-frame-toggle]").forEach((input) => {
        const shell = input.closest(".product-text-personalizer__frame-controls") || input.closest("label") || input;
        shell.remove();
      });
      root.querySelectorAll("[data-frame-options], .product-text-personalizer__frame-options, .product-text-personalizer__frame-controls").forEach((node) => node.remove());
      root.querySelectorAll(".product-text-personalizer__field-grid--text-main").forEach((grid) => {
        grid.style.gridTemplateColumns = "minmax(0, 1fr)";
        grid.style.maxWidth = "none";
        const input = grid.querySelector("[data-text-input]");
        if (input) input.style.boxSizing = "border-box";
      });
      this.autoColorEnabled = Boolean(root.closest('[data-personalization-auto-color="true"]'));
      this.colorManuallyChosen = false;
      this.autoColorKey = "";
      this.autoColorRequest = 0;
      this.defaultTextAnchor = root.closest('[data-personalization-default-anchor]')?.dataset.personalizationDefaultAnchor === "bottom" ? "bottom" : "center";
      this.productId = Number(root.dataset.productId || 0);
      this.personalizationOptionName =
        root.dataset.personalizationOptionName || "Personalization";
      this.standardOptionValue = root.dataset.standardOptionValue || "Standard";
      this.customOptionValue = root.dataset.customOptionValue || "Custom text";
      this.enableToggle = root.querySelector("[data-enabled-toggle]");
      this.header = root.querySelector(".product-text-personalizer__header");
      this.toggle = root.querySelector(".product-text-personalizer__toggle");
      this.controls = root.querySelector("[data-controls]");
      this.previewCard = root.querySelector(".product-text-personalizer__preview-card");
      this.previewSurface = root.querySelector("[data-preview-surface]");
      this.previewImage = root.querySelector("[data-preview-image]");
      this.previewEmpty = root.querySelector("[data-preview-empty]");
      this.textLayer = root.querySelector("[data-text-layer]");
      this.textInput = root.querySelector("[data-text-input]");
      this.textFontInput = root.querySelector("[data-text-font]");
      this.textSizeInput = root.querySelector("[data-text-size]");
      this.textColorInput = root.querySelector("[data-text-color]");
      this.textCenterButton = root.querySelector("[data-text-center]");
      this.frameToggleInput = root.querySelector("[data-frame-toggle]");
      this.frameOptions = root.querySelector("[data-frame-options]");
      this.frameShapeInput = root.querySelector("[data-frame-shape]");
      this.framePositionField = root.querySelector("[data-frame-position-field]");
      this.framePositionInput = root.querySelector("[data-frame-position]");
      this.frameBorderColorInput = root.querySelector("[data-frame-border-color]");
      this.frameFillColorInput = root.querySelector("[data-frame-fill-color]");
      this.status = root.querySelector("[data-status]");
      this.fallbackPreviewImageUrl = normalizeMediaUrl(
        root.dataset.fallbackPreviewImage || root.dataset.previewImage || "",
      );
      const sharedNamePreview = this.getScope().querySelector("[data-p1-personalization-chooser]") ||
        root.closest('[data-personalization-surface-family="google-pixel"]');
      this.previewSample = sharedNamePreview ? "EMILY" : "";
      this.defaultTextSample = sharedNamePreview
        ? ""
        : String(root.dataset.defaultText ?? DEFAULT_TEXT_SAMPLE).trim();
      this.defaultTextColor = root.dataset.defaultColor || DEFAULT_TEXT_COLOR;
      this.defaultTextSize = this.previewSample ? 33 : Number(root.dataset.defaultSize || this.textSizeInput?.value || DEFAULT_TEXT_SIZE);
      const defaultSurfaceProfile = this.getSurfaceProfile(this.fallbackPreviewImageUrl);
      if (defaultSurfaceProfile) {
        this.defaultTextAnchor = "bottom";
        this.defaultTextSize = defaultSurfaceProfile.id === "google-pixel-case-2026"
          ? PIXEL_DEFAULT_TEXT_SIZE
          : HOLDER_DEFAULT_TEXT_SIZE;
      }
      this.forms = this.findProductForms();
      this.themeProduct = this.getThemeProduct();
      this.deviceOptionName = this.resolveDeviceOptionName();
      this.allowedSubmitForm = null;
      this.pendingSubmitters = new WeakMap();
      this.textGesture = null;
      this.textPointers = new Map();
      this.previewMediaObserver = null;
      this.previewSyncFrame = 0;
      this.pendingPreviewSyncMarkDirty = false;
      this.introDock = null;
      this.introDockedBlock = null;
      this.introDockSyncFrame = 0;
      this.introDockMediaQuery = window.matchMedia?.("(min-width: 1200px)") || null;
      this.state = {
        enabled: this.enableToggle?.checked || false,
        previewImageUrl: this.fallbackPreviewImageUrl,
        fileId: "",
        fileUrl: "",
        designDirty: false,
        uploadingDesign: false,
        text: {
          content: "",
          fontKey: this.textFontInput?.value || "classic-serif",
          size: Number(this.textSizeInput?.value || this.defaultTextSize || DEFAULT_TEXT_SIZE),
          color: this.textColorInput?.value || this.defaultTextColor,
          anchor: this.defaultTextAnchor,
        },
        frame: {
          enabled: false,
          shape: this.frameShapeInput?.value || "oval",
          position: this.defaultTextAnchor === "bottom" ? "bottom" : (this.framePositionInput?.value || "center"),
          borderColor: this.frameBorderColorInput?.value || DEFAULT_FRAME_BORDER_COLOR,
          fillColor: this.frameFillColorInput?.value || DEFAULT_FRAME_FILL_COLOR,
        },
        textTransform: {
          x: 0,
          y: 0,
          scale: 1,
          rotation: 0,
        },
      };
    }

    init() {
      const initialOption = this.getCurrentThemeVariant()?.selectedOptions?.find(
        (option) => String(option.name).toLowerCase() === this.personalizationOptionName.toLowerCase(),
      );
      if (initialOption) {
        this.state.enabled = initialOption.value === this.customOptionValue;
        if (this.enableToggle) this.enableToggle.checked = this.state.enabled;
      }
      if (this.textColorInput && !this.textColorInput.value) {
        this.textColorInput.value = this.defaultTextColor;
      }
      if (this.textSizeInput) {
        this.textSizeInput.value = String(this.defaultTextSize);
      }
      if (this.frameBorderColorInput && !this.frameBorderColorInput.value) {
        this.frameBorderColorInput.value = DEFAULT_FRAME_BORDER_COLOR;
      }
      if (this.frameFillColorInput && !this.frameFillColorInput.value) {
        this.frameFillColorInput.value = DEFAULT_FRAME_FILL_COLOR;
      }
      this.state.frame.position = this.normalizeFramePosition(this.state.frame.position);
      if (this.framePositionInput) {
        this.framePositionInput.value = this.state.frame.position;
      }
      this.state.text.size = this.defaultTextSize;
      if (this.state.enabled) {
        this.applyDefaultCustomizationState();
      }

      this.hidePersonalizationPicker();
      this.syncPreviewImageFromMainProduct({markDirty: false});
      this.bindEvents();
      this.setupTextPositionControls();
      this.previewImage?.addEventListener("load", () => { if (this.getSurfaceProfile()) this.render(); });
      if (window.ResizeObserver && this.previewSurface && this.getSurfaceProfile()) {
        this.surfaceResizeObserver = new ResizeObserver(() => this.render());
        this.surfaceResizeObserver.observe(this.previewSurface);
      }
      this.bindFormEvents();
      this.bindVariantEvents();
      this.bindMainProductPreviewSync();
      this.setupIntroDock();
      window.addEventListener("pointermove", (event) => this.handleTextGestureMove(event));
      window.addEventListener("pointerup", (event) => this.finishTextGesture(event));
      window.addEventListener("pointercancel", (event) => this.finishTextGesture(event));
      this.syncPersonalizationVariant({force: true});
      this.schedulePreviewImageSync({markDirty: false});
      window.setTimeout(() => this.schedulePreviewImageSync({markDirty: false}), 150);
      document.fonts?.ready
        ?.then(() => this.render())
        .catch(() => {});
      this.render();
    }

    bindEvents() {
      this.enableToggle?.addEventListener("change", () => {
        this.autoColorRequest += 1;
        this.autoColorKey = "";
        this.state.enabled = this.enableToggle.checked;
        this.resetUploadState();
        if (this.state.enabled) {
          this.applyDefaultCustomizationState();
        }
        this.syncPersonalizationVariant({force: true});
        this.schedulePreviewImageSync({markDirty: true});
        window.setTimeout(() => this.schedulePreviewImageSync({markDirty: true}), 150);
        this.render();
      });

      this.textInput?.addEventListener("input", () => {
        const hadText = this.hasTextContent();
        this.state.text.content = this.textInput.value;
        if (this.status?.dataset.state === "error") this.setStatus("", "idle");
        if (!hadText && this.hasTextContent() && !this.previewSample) {
          this.resetTextPlacement({resetScale: true, resetRotation: true});
        }
        this.markDesignDirty();
        this.render();
      });

      this.textFontInput?.addEventListener("change", () => {
        this.state.text.fontKey = this.textFontInput.value;
        this.markDesignDirty();
        this.render();
      });

      this.textSizeInput?.addEventListener("input", () => {
        this.state.text.size = Number(this.textSizeInput.value);
        this.markDesignDirty();
        this.render();
      });

      this.textColorInput?.addEventListener("input", () => {
        this.colorManuallyChosen = true;
        this.autoColorRequest += 1;
        this.state.text.color = this.textColorInput.value;
        this.markDesignDirty();
        this.render();
      });

      this.textCenterButton?.addEventListener("click", () => {
        this.resetTextPlacement();
        this.markDesignDirty();
        this.render();
      });
    }

    applyDefaultCustomizationState() {
      if (!this.hasTextContent() && this.defaultTextSample) {
        this.state.text.content = this.defaultTextSample;
        if (this.textInput) {
          this.textInput.value = this.defaultTextSample;
        }
        this.resetTextPlacement({resetScale: true, resetRotation: true});
      }

      if (!this.state.text.color) {
        this.state.text.color = this.defaultTextColor;
      }

      if (this.textColorInput && !this.textColorInput.value) {
        this.textColorInput.value = this.defaultTextColor;
      }
    }

    findProductForms() {
      const wrapper = this.root.closest(".m-main-product--wrapper") || document;
      return Array.from(wrapper.querySelectorAll('form[action*="/cart/add"]'));
    }

    getScope() {
      return this.root.closest(".m-main-product--wrapper") || document;
    }

    getThemeProduct() {
      if (!this.productId) return null;
      const product = (
        window._themeProducts?.[this.productId] ||
        window._themeProducts?.[String(this.productId)] ||
        null
      );
      if (!product) return null;
      // Liquid variants use positional options and prices in cents. Keep the
      // existing customizer's named options and major-unit price contract.
      const normalizeVariant = (variant) => {
        if (!variant || variant.selectedOptions) return variant;
        return {
          ...variant,
          price: Number(variant.price) / 100,
          selectedOptions: (product.options || []).map((option, index) => ({
            name: option.name || option,
            value: variant.options?.[index] ?? variant[`option${index + 1}`],
          })),
        };
      };
      return {
        ...product,
        variants: (product.variants || []).map(normalizeVariant),
        selected_variant: normalizeVariant(product.selected_variant),
        selected_or_first_available_variant: normalizeVariant(product.selected_or_first_available_variant),
      };
    }

    resolveDeviceOptionName() {
      const option = (this.themeProduct?.options || []).find(
        (entry) =>
          String(entry?.name || entry || "").toLowerCase() !==
          String(this.personalizationOptionName).toLowerCase(),
      );
      return option?.name || (typeof option === "string" ? option : "");
    }

    getOptionContainers(optionName) {
      const escapedName = escapeSelector(optionName);
      return Array.from(this.getScope().querySelectorAll(`[data-option-name="${escapedName}"]`));
    }

    getOptionInputs(optionName) {
      return this.getOptionContainers(optionName).flatMap((container) =>
        Array.from(container.querySelectorAll("select, input")),
      );
    }

    hidePersonalizationPicker() {
      const containers = this.getOptionContainers(this.personalizationOptionName);
      for (const container of containers) {
        const optionBlock = container.closest(".m-product-option");
        if (optionBlock) {
          optionBlock.hidden = true;
        }
      }
    }

    bindVariantEvents() {
      const optionInputs = this.getOptionInputs(this.deviceOptionName);
      for (const input of optionInputs) {
        if (input.dataset.productTextPersonalizerVariantBound === "true") {
          continue;
        }

        input.dataset.productTextPersonalizerVariantBound = "true";
        input.addEventListener("change", () => {
          window.requestAnimationFrame(() => {
            this.syncPersonalizationVariant({force: true});
            this.schedulePreviewImageSync({markDirty: true});
            window.setTimeout(() => this.schedulePreviewImageSync({markDirty: true}), 150);
          });
        });
      }
    }

    bindMainProductPreviewSync() {
      const scope = this.getScope();
      const scheduleDirtySync = () => {
        this.schedulePreviewImageSync({markDirty: true});
        window.setTimeout(() => this.schedulePreviewImageSync({markDirty: true}), 150);
      };

      scope.addEventListener(
        "click",
        (event) => {
          if (!(event.target instanceof Element)) return;
          if (
            event.target.closest(
              "media-gallery, media-gallery-mobile, .m-product-media--slider__navigation, .m-product-media--slider__thumbnails",
            )
          ) {
            scheduleDirtySync();
          }
        },
        true,
      );

      scope.addEventListener(
        "change",
        (event) => {
          if (!(event.target instanceof Element)) return;
          if (event.target.closest("variant-picker, .m-product-option, form[action*='/cart/add']")) {
            scheduleDirtySync();
          }
        },
        true,
      );

      for (const eventName of [
        "variant:change",
        "variantChange",
        "variant:changed",
        "product:variant-change",
        "product:media-change",
        "mediaGallery:change",
      ]) {
        document.addEventListener(
          eventName,
          (event) => {
            if (
              event.target &&
              event.target instanceof Node &&
              event.target !== document &&
              !scope.contains(event.target)
            ) {
              return;
            }
            scheduleDirtySync();
          },
          true,
        );
      }

      if (!window.MutationObserver) {
        return;
      }

      this.previewMediaObserver = new MutationObserver((mutations) => {
        if (mutations.some((mutation) => this.isMainProductMediaMutation(mutation))) {
          this.schedulePreviewImageSync({markDirty: true});
        }
      });
      this.previewMediaObserver.observe(scope, {
        attributes: true,
        attributeFilter: ["class", "src", "srcset", "style", "hidden", "data-media-src"],
        childList: true,
        subtree: true,
      });
    }

    setupIntroDock() {
      if (this.getScope().querySelector("[data-p1-personalization-chooser]")) {
        this.root.dataset.p1Chooser = "true";
        return;
      }
      if (this.root.closest('[data-personalization-surface-family="google-pixel"]')) {
        return;
      }
      if (!this.header || !this.toggle) {
        return;
      }

      this.introDock = document.createElement("div");
      this.introDock.className = "product-text-personalizer__intro-dock";
      this.introDock.setAttribute("aria-label", "Text personalization");

      const scheduleIntroDockSync = () => this.scheduleIntroDockSync();
      window.addEventListener("resize", scheduleIntroDockSync);
      this.introDockMediaQuery?.addEventListener?.("change", scheduleIntroDockSync);
      this.scheduleIntroDockSync();
      window.setTimeout(scheduleIntroDockSync, 150);
    }

    scheduleIntroDockSync() {
      if (this.introDockSyncFrame) {
        return;
      }

      this.introDockSyncFrame = window.requestAnimationFrame(() => {
        this.introDockSyncFrame = 0;
        this.syncIntroDock();
      });
    }

    syncIntroDock() {
      const variantBlock = this.findVariantPickerBlock();
      const shouldDock =
        Boolean(variantBlock) &&
        Boolean(this.introDockMediaQuery?.matches) &&
        variantBlock.getBoundingClientRect().width >= 500;

      if (shouldDock) {
        this.dockIntro(variantBlock);
        return;
      }

      this.restoreIntro();
    }

    dockIntro(variantBlock) {
      if (!this.introDock || !this.header || !this.toggle) {
        return;
      }

      if (this.introDockedBlock && this.introDockedBlock !== variantBlock) {
        this.introDockedBlock.classList.remove("product-text-personalizer-layout-docked");
      }

      if (!variantBlock.contains(this.introDock)) {
        variantBlock.appendChild(this.introDock);
      }

      this.introDock.appendChild(this.toggle);
      this.introDock.appendChild(this.header);
      variantBlock.classList.add("product-text-personalizer-layout-docked");
      this.root.classList.add("product-text-personalizer--intro-docked");
      this.introDockedBlock = variantBlock;
    }

    restoreIntro() {
      if (!this.header || !this.toggle) {
        return;
      }

      const referenceNode = this.previewCard || this.controls || this.status || null;
      this.root.insertBefore(this.toggle, referenceNode);
      this.root.insertBefore(this.header, referenceNode);
      this.root.classList.remove("product-text-personalizer--intro-docked");

      if (this.introDockedBlock) {
        this.introDockedBlock.classList.remove("product-text-personalizer-layout-docked");
        this.introDockedBlock = null;
      }

      if (this.introDock?.parentNode) {
        this.introDock.parentNode.removeChild(this.introDock);
      }
    }

    findVariantPickerBlock() {
      const optionContainer =
        this.getOptionContainers(this.deviceOptionName).find((container) => !this.root.contains(container)) ||
        this.getScope().querySelector(".main-product__block-variant_picker .m-product-option");

      return (
        optionContainer?.closest(".main-product__block-variant_picker") ||
        this.getScope().querySelector(".main-product__block-variant_picker") ||
        null
      );
    }

    isMainProductMediaMutation(mutation) {
      const target = mutation.target;
      if (!(target instanceof Element)) {
        return false;
      }
      if (this.root.contains(target)) {
        return false;
      }

      return Boolean(
        target.closest(
          "media-gallery, media-gallery-mobile, variant-picker, .m-product-option, form[action*='/cart/add']",
        ),
      );
    }

    schedulePreviewImageSync(options = {}) {
      const {markDirty = true, delay = 0} = options;

      if (delay > 0) {
        window.setTimeout(() => this.schedulePreviewImageSync({markDirty}), delay);
        return;
      }

      this.pendingPreviewSyncMarkDirty = this.pendingPreviewSyncMarkDirty || markDirty;
      if (this.previewSyncFrame) {
        return;
      }

      this.previewSyncFrame = window.requestAnimationFrame(() => {
        const shouldMarkDirty = this.pendingPreviewSyncMarkDirty;
        this.previewSyncFrame = 0;
        this.pendingPreviewSyncMarkDirty = false;
        this.syncPreviewImageFromMainProduct({markDirty: shouldMarkDirty});
      });
    }

    syncPreviewImageFromMainProduct(options = {}) {
      const nextPreviewImageUrl =
        this.resolveCurrentMainProductPreviewImageUrl() || this.fallbackPreviewImageUrl;
      this.setPreviewImageUrl(nextPreviewImageUrl, options);
    }

    setPreviewImageUrl(url, options = {}) {
      const {markDirty = true} = options;
      const nextPreviewImageUrl = normalizeMediaUrl(url);
      if (!nextPreviewImageUrl) {
        this.renderPreviewImageAvailability();
        return false;
      }

      const previousPreviewImageUrl = normalizeMediaUrl(this.resolvePreviewImageUrl());
      this.state.previewImageUrl = nextPreviewImageUrl;
      this.root.dataset.previewImage = nextPreviewImageUrl;
      this.updatePreviewImageElement(nextPreviewImageUrl);
      this.renderTextOverlay();
      void this.applyAutomaticTextColor();

      if (previousPreviewImageUrl === nextPreviewImageUrl) {
        this.syncHiddenFields();
        return false;
      }

      if (markDirty && this.hasActiveCustomization()) {
        this.markDesignDirty();
      } else {
        this.syncHiddenFields();
      }

      return true;
    }

    updatePreviewImageElement(url) {
      const image = this.ensurePreviewImageElement();
      if (image) {
        image.removeAttribute("srcset");
        image.removeAttribute("sizes");
        image.src = url;
        image.hidden = false;
      }
      this.renderPreviewImageAvailability();
    }

    ensurePreviewImageElement() {
      if (this.previewImage) {
        return this.previewImage;
      }
      if (!this.previewSurface) {
        return null;
      }

      const image = document.createElement("img");
      image.className = "product-text-personalizer__preview-image";
      image.dataset.previewImage = "true";
      image.alt = this.root.dataset.productTitle || "";
      image.loading = "lazy";
      this.previewSurface.insertBefore(image, this.textLayer || this.previewEmpty || null);
      this.previewImage = image;
      return image;
    }

    renderPreviewImageAvailability() {
      const hasPreviewImage = Boolean(this.resolvePreviewImageUrl());
      if (this.previewImage) {
        this.previewImage.hidden = !hasPreviewImage;
      }
      if (this.previewEmpty) {
        this.previewEmpty.hidden = hasPreviewImage;
      }
    }

    resolveCurrentMainProductPreviewImageUrl() {
      const activeMediaUrl = this.resolveActiveGalleryMediaUrl();
      if (activeMediaUrl) {
        return activeMediaUrl;
      }

      return this.resolveCurrentVariantPreviewImageUrl();
    }

    resolveActiveGalleryMediaUrl() {
      const galleries = this.getMainProductGalleries();

      for (const gallery of galleries) {
        const activeMediaUrl = this.resolveGalleryActiveMediaUrl(gallery);
        if (activeMediaUrl) {
          return activeMediaUrl;
        }
      }

      return "";
    }

    getMainProductGalleries() {
      return Array.from(this.getScope().querySelectorAll("media-gallery, media-gallery-mobile"))
        .filter((gallery) => !this.root.contains(gallery) && !gallery.contains(this.root))
        .sort((first, second) => Number(isVisibleElement(second)) - Number(isVisibleElement(first)));
    }

    resolveGalleryActiveMediaUrl(gallery) {
      const activeSelectors = [
        ".m-product-media--slider__images .swiper-slide-active",
        ".m-product-media--slider__images .swiper-slide[aria-current='true']",
        ".m-product-media--slider__images .swiper-slide.is-selected",
        ".m-product-media--slider__images .swiper-slide.active",
      ];

      for (const selector of activeSelectors) {
        const activeSlide = gallery.querySelector(selector);
        const activeSlideUrl = this.extractPreviewImageUrl(activeSlide);
        if (activeSlideUrl) {
          return activeSlideUrl;
        }
      }

      const visibleMedia = Array.from(
        gallery.querySelectorAll(
          ".m-product-media--slider__images .m-product-media[data-media-src], .m-product-media--list .m-product-media[data-media-src]",
        ),
      ).find((media) => isVisibleElement(media));
      const visibleMediaUrl = this.extractPreviewImageUrl(visibleMedia);
      if (visibleMediaUrl) {
        return visibleMediaUrl;
      }

      return this.extractPreviewImageUrl(
        gallery.querySelector(
          ".m-product-media--slider__images .m-product-media[data-media-src], .m-product-media--list .m-product-media[data-media-src]",
        ),
      );
    }

    extractPreviewImageUrl(node) {
      if (!(node instanceof Element)) {
        return "";
      }

      const mediaNode = node.matches(".m-product-media[data-media-src]")
        ? node
        : node.querySelector(".m-product-media[data-media-src]");
      const mediaUrl = normalizeMediaUrl(mediaNode?.dataset.mediaSrc || "");
      if (mediaUrl) {
        return mediaUrl;
      }

      const image = node.matches("img") ? node : node.querySelector("img");
      return normalizeMediaUrl(image?.currentSrc || image?.src || "");
    }

    resolveCurrentVariantPreviewImageUrl() {
      const currentVariant = this.getCurrentThemeVariant();
      const featuredMedia = currentVariant?.featured_media || currentVariant?.featuredMedia;
      const previewImage = featuredMedia?.preview_image || featuredMedia?.previewImage;
      const featuredImage =
        currentVariant?.featured_image ||
        currentVariant?.featuredImage ||
        currentVariant?.image ||
        previewImage;

      return normalizeMediaUrl(
        featuredImage?.src ||
          featuredImage?.url ||
          previewImage?.src ||
          previewImage?.url ||
          featuredMedia?.src ||
          featuredMedia?.url ||
          "",
      );
    }

    getSelectedDeviceValue() {
      const containers = this.getOptionContainers(this.deviceOptionName);

      for (const container of containers) {
        const select = container.querySelector("select");
        if (select?.value) {
          return select.value;
        }

        const checkedInput = Array.from(container.querySelectorAll("input")).find(
          (input) => input.checked,
        );
        if (checkedInput?.value) {
          return checkedInput.value;
        }

        if (container.dataset.selectedValue) {
          return container.dataset.selectedValue;
        }
      }

      const currentVariant = this.getCurrentThemeVariant();
      return currentVariant?.selectedOptions?.find(
        (option) =>
          String(option?.name || "").toLowerCase() !==
          String(this.personalizationOptionName).toLowerCase(),
      )?.value;
    }

    getCurrentThemeVariant() {
      const selectedVariantId = this.getCurrentFormVariantId();
      if (!selectedVariantId) {
        return this.themeProduct?.selected_variant || this.themeProduct?.selected_or_first_available_variant || null;
      }

      return (
        (this.themeProduct?.variants || []).find((variant) => String(variant.id) === String(selectedVariantId)) ||
        this.themeProduct?.selected_variant ||
        this.themeProduct?.selected_or_first_available_variant ||
        null
      );
    }

    getCurrentFormVariantId() {
      return (
        this.forms
          .map((form) => form.querySelector('input[name="id"]'))
          .find((field) => field?.value)?.value || ""
      );
    }

    getVariantBySelection(deviceValue, personalizationValue) {
      if (!(this.themeProduct?.variants || []).length || (this.deviceOptionName && !deviceValue)) {
        return null;
      }

      return (
        this.themeProduct.variants.find((variant) => {
          const selectedOptions = variant.selectedOptions || [];
          const deviceOption = selectedOptions.find(
            (option) =>
              String(option?.name || "").toLowerCase() ===
              String(this.deviceOptionName).toLowerCase(),
          );
          const personalizationOption = selectedOptions.find(
            (option) =>
              String(option?.name || "").toLowerCase() ===
              String(this.personalizationOptionName).toLowerCase(),
          );

          const resolvedPersonalization =
            personalizationOption?.value || this.standardOptionValue;

          return (
            (!this.deviceOptionName || deviceOption?.value === deviceValue) &&
            resolvedPersonalization === personalizationValue
          );
        }) || null
      );
    }

    syncPersonalizationVariant(options = {}) {
      const {force = false} = options;
      const targetOptionValue = this.state.enabled
        ? this.customOptionValue
        : this.standardOptionValue;
      const currentDeviceValue = this.getSelectedDeviceValue();
      const targetVariant = this.getVariantBySelection(currentDeviceValue, targetOptionValue);

      if (!force && !targetVariant) {
        return;
      }

      this.hidePersonalizationPicker();
      this.setOptionValue(this.personalizationOptionName, targetOptionValue);

      if (!targetVariant) {
        return;
      }

      this.applyVariantFallback(targetVariant);
      this.applyPriceFallback(targetVariant);
    }

    setOptionValue(optionName, targetValue) {
      let didUpdate = false;

      for (const container of this.getOptionContainers(optionName)) {
        const select = container.querySelector("select");
        if (select && select.value !== targetValue) {
          select.value = targetValue;
          select.dispatchEvent(new Event("change", {bubbles: true}));
          didUpdate = true;
          continue;
        }

        const input = Array.from(container.querySelectorAll("input")).find(
          (candidate) => candidate.value === targetValue,
        );
        if (input && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event("change", {bubbles: true}));
          didUpdate = true;
        }
      }

      return didUpdate;
    }

    applyVariantFallback(targetVariant) {
      const variantId = String(targetVariant.id || "");
      if (!variantId) return;

      const scope = this.getScope();
      const idInputs = scope.querySelectorAll('input[name="id"]');

      for (const input of idInputs) {
        input.value = variantId;
        if (input.dataset.selectedVariant !== undefined) {
          input.dataset.selectedVariant = variantId;
        }
      }
    }

    applyPriceFallback(targetVariant) {
      const formattedPrice = formatCurrency(targetVariant.price);
      if (!formattedPrice) return;

      const scope = this.getScope();
      const priceNodes = scope.querySelectorAll(
        ".product-block-group--price .m-price-item--regular, .product-block-group--price .m-price-item--sale",
      );

      for (const node of priceNodes) {
        node.textContent = formattedPrice;
      }

      const stickyPriceNodes = document.querySelectorAll(
        ".m-sticky-addtocart .m-price-item--regular, .m-sticky-addtocart .m-price-item--sale",
      );

      for (const node of stickyPriceNodes) {
        node.textContent = formattedPrice;
      }
    }

    refreshForms() {
      this.forms = this.findProductForms();
      this.bindFormEvents();
      this.bindVariantEvents();
    }

    bindFormEvents() {
      for (const form of this.forms) {
        if (form.dataset.productTextPersonalizerBound === "true") {
          continue;
        }

        form.dataset.productTextPersonalizerBound = "true";
        form.addEventListener("click", (event) => this.captureSubmitClick(event, form), true);
        form.addEventListener("submit", (event) => void this.handleFormSubmit(event, form), true);
      }
    }

    captureSubmitClick(event, form) {
      const submitter = this.resolveSubmitterFromTarget(event.target);
      if (!submitter) return;

      this.pendingSubmitters.set(form, submitter);

      if (this.allowedSubmitForm === form) {
        return;
      }

      const gate = this.evaluateFormSubmission(form);
      if (!gate.shouldBlock) {
        return;
      }

      this.blockFormSubmission(event);

      if (gate.validationError) {
        this.setStatus(gate.validationError, "error");
        return;
      }

      void this.resumeSubmissionAfterUpload(form, submitter);
    }

    async handleFormSubmit(event, form) {
      if (this.allowedSubmitForm === form) {
        this.allowedSubmitForm = null;
        this.pendingSubmitters.delete(form);
        return;
      }

      const submitter =
        event.submitter ||
        this.pendingSubmitters.get(form) ||
        this.getPreferredSubmitter(form);
      if (submitter) {
        this.pendingSubmitters.set(form, submitter);
      }

      const gate = this.evaluateFormSubmission(form);
      if (!gate.shouldBlock) {
        this.pendingSubmitters.delete(form);
        return;
      }

      this.blockFormSubmission(event);

      if (gate.validationError) {
        this.setStatus(gate.validationError, "error");
        return;
      }

      void this.resumeSubmissionAfterUpload(form, submitter);
    }

    evaluateFormSubmission() {
      this.refreshForms();
      this.syncHiddenFields();
      const validationError = this.getValidationError();

      if (validationError) {
        return {shouldBlock: true, validationError};
      }

      if (!this.needsDesignUpload()) {
        this.syncHiddenFields();
        return {shouldBlock: false, validationError: ""};
      }

      return {shouldBlock: true, validationError: ""};
    }

    blockFormSubmission(event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function") {
        event.stopImmediatePropagation();
      }
    }

    resolveSubmitterFromTarget(target) {
      if (!(target instanceof Element)) return null;
      const submitter = target.closest('button, input[type="submit"], input[type="image"]');
      return this.isSubmitControl(submitter) ? submitter : null;
    }

    isSubmitControl(control) {
      if (!control) return false;
      if (control instanceof HTMLButtonElement) {
        return (control.getAttribute("type") || "submit").toLowerCase() === "submit";
      }
      if (control instanceof HTMLInputElement) {
        return ["submit", "image"].includes(control.type.toLowerCase());
      }
      return false;
    }

    getPreferredSubmitter(form) {
      return (
        Array.from(form.querySelectorAll('button, input[type="submit"], input[type="image"]')).find(
          (control) => this.isSubmitControl(control) && !control.disabled,
        ) || null
      );
    }

    setSubmitControlsBusy(form, isBusy) {
      const controls = Array.from(
        form.querySelectorAll('button, input[type="submit"], input[type="image"]'),
      ).filter((control) => this.isSubmitControl(control));

      for (const control of controls) {
        if (isBusy) {
          control.dataset.productTextPersonalizerWasDisabled = control.disabled ? "true" : "false";
          control.disabled = true;
          control.setAttribute("aria-busy", "true");
        } else {
          const wasDisabled = control.dataset.productTextPersonalizerWasDisabled === "true";
          control.disabled = wasDisabled;
          control.removeAttribute("aria-busy");
          delete control.dataset.productTextPersonalizerWasDisabled;
        }
      }
    }

    async resumeSubmissionAfterUpload(form, submitter) {
      if (this.state.uploadingDesign) {
        return;
      }

      this.setSubmitControlsBusy(form, true);

      try {
        await this.uploadCustomizationDesign();
        this.allowedSubmitForm = form;
        const nextSubmitter =
          submitter && submitter.isConnected && !submitter.disabled
            ? submitter
            : this.pendingSubmitters.get(form) || this.getPreferredSubmitter(form);

        if (typeof form.requestSubmit === "function") {
          if (nextSubmitter) {
            form.requestSubmit(nextSubmitter);
          } else {
            form.requestSubmit();
          }
        } else {
          HTMLFormElement.prototype.submit.call(form);
        }
      } catch (error) {
        this.allowedSubmitForm = null;
        this.setStatus(error.message || "Failed to prepare your personalized preview.", "error");
      } finally {
        this.setSubmitControlsBusy(form, false);
      }
    }

    hasTextContent() {
      return Boolean(this.state.text.content.trim());
    }

    getPreviewText() {
      return this.state.text.content.trim() || (this.state.enabled ? this.previewSample : "");
    }

    hasActiveCustomization() {
      return this.state.enabled && this.hasTextContent();
    }

    resetUploadState() {
      this.state.designDirty = false;
      this.state.fileId = "";
      this.state.fileUrl = "";
      this.syncHiddenFields();
    }

    markDesignDirty() {
      if (!this.state.enabled) {
        this.resetUploadState();
        return;
      }

      this.state.designDirty = true;
      this.state.fileId = "";
      this.state.fileUrl = "";
      this.syncHiddenFields();
    }

    getValidationError() {
      if (!this.state.enabled) {
        return "";
      }

      if (!this.resolvePreviewImageUrl()) {
        return "Product preview image is unavailable for text personalization on this product.";
      }

      if (!this.hasTextContent()) {
        return "Please enter your name before adding this product to cart.";
      }

      return "";
    }

    needsDesignUpload() {
      return this.hasActiveCustomization() && (this.state.designDirty || !this.state.fileId || !this.state.fileUrl);
    }

    async uploadCustomizationDesign() {
      this.state.uploadingDesign = true;
      this.setStatus("Preparing your personalized preview...", "loading");

      try {
        const designFile = await this.buildCustomizationFile();
        const uploadData = await this.uploadFile(designFile);
        this.state.fileId = uploadData.fileId;
        this.state.fileUrl = uploadData.fileUrl;
        this.state.designDirty = false;
        this.syncHiddenFields();
        this.setStatus("Your personalized preview is ready.", "success");
      } finally {
        this.state.uploadingDesign = false;
      }
    }

    async buildCustomizationFile() {
      if (!this.hasActiveCustomization()) {
        throw new Error("Nothing to export yet.");
      }

      const previewImageUrl = this.resolvePreviewImageUrl();
      if (!previewImageUrl) {
        throw new Error("Preview image is unavailable for export.");
      }

      const image = await loadImage(previewImageUrl);
      const canvas = document.createElement("canvas");
      canvas.width = image.naturalWidth || image.width || 1400;
      canvas.height = image.naturalHeight || image.height || 1750;
      const context = canvas.getContext("2d");

      if (!context) {
        throw new Error("Browser canvas is unavailable for text personalization export.");
      }

      context.drawImage(image, 0, 0, canvas.width, canvas.height);
      await this.drawTextLayer(context, {x: 0, y: 0, width: canvas.width, height: canvas.height}, this.getRenderedPreviewRect());

      return canvasToFile(canvas, this.buildDesignFilename());
    }

    getSurfaceProfile(url = this.resolvePreviewImageUrl()) {
      let filename;
      try {
        filename = decodeURIComponent(new URL(url, window.location.href).pathname).split('/').pop();
      } catch {
        return null;
      }
      if (this.root.closest('[data-personalization-surface-family="google-pixel"]')) {
        const pixelMatch = filename.match(/^.+-google-pixel-case(?:-(pixel-10-front-view|front|standing-angle|flat-angle|bottom-angle|low-angle|new-(?:front|bottom-angle|low-angle)-\d{8}))?(?:_\d+x\d*)?\.(?:jpe?g|png|webp)$/i);
        if (pixelMatch) {
          const angle = (pixelMatch[1] || '').toLowerCase().replace(/^new-(.+)-\d{8}$/, '$1');
          const view = {'': 1, 'pixel-10-front-view': 2, front: 3, 'bottom-angle': 4,
            'low-angle': 5, 'standing-angle': 6, 'flat-angle': 7}[angle];
          return {id: 'google-pixel-case-2026', view, planeWidth: 500, planeHeight: 1130,
            nameAnchor: PIXEL_NAME_ANCHOR, ...PIXEL_SURFACES[view]};
        }
        return null;
      }
      const match = filename.match(/(?:^|-)Magholder-\d{6}-\d+-([1-5])(?:-v\d+)?(?:_[^./]+)?\.(?:jpe?g|png|webp)$/i);
      if (match) return {view: Number(match[1]), ...HOLDER_SURFACES[match[1]]};
      const holder = this.root.closest('[data-personalization-holder-family="printed"]');
      if (!holder) return null;
      try {
        const front = decodeURIComponent(new URL(holder.dataset.personalizationHolderFront, window.location.href).pathname).split('/').pop();
        const normalized = value => value.replace(/_\d+x\d*(?=\.)/i, '');
        if (normalized(filename) === normalized(front)) return {view: 1, ...HOLDER_SURFACES[1]};
      } catch {}
      const legacyMatch = filename.match(/(?:^|-)Magholder-(?:PC)?\d+(?:[-_][^.]*)?-([1-4])(?:_[^./]+)?\.(?:jpe?g|png|webp)$/i);
      if (legacyMatch) {
        const view = {1: 2, 2: 3, 3: 5, 4: 4}[legacyMatch[1]];
        return {view, ...HOLDER_SURFACES[view]};
      }
      if (/^Magholder-(?:PC)?\d+(?:_[^./]+)?\.(?:jpe?g|png|webp)$/i.test(filename)) {
        return {view: 2, ...HOLDER_SURFACES[2]};
      }
      return null;
    }

    getRenderedImageRect() {
      const imageRect = this.previewImage?.getBoundingClientRect();
      const surfaceRect = this.previewSurface?.getBoundingClientRect();
      return {
        left: imageRect?.width ? imageRect.left : (surfaceRect?.left || 0),
        top: imageRect?.height ? imageRect.top : (surfaceRect?.top || 0),
        width: Math.max(1, imageRect?.width || surfaceRect?.width || 1),
        height: Math.max(1, imageRect?.height || surfaceRect?.height || 1),
      };
    }

    getSurfaceGeometry(bounds = this.getRenderedImageRect()) {
      const profile = this.getSurfaceProfile();
      if (!profile) return null;
      const width = bounds.width * (profile.planeWidth || 665) / 1254;
      const height = bounds.width * (profile.planeHeight || 1014) / 1254;
      const plane = [[0, 0], [width, 0], [width, height], [0, height]];
      const corners = profile.corners.map(([x, y]) => [
        (bounds.x || 0) + x / profile.width * bounds.width,
        (bounds.y || 0) + y / profile.height * bounds.height,
      ]);
      const matrix = surfaceHomography(plane, corners);
      const inverse = surfaceHomography(corners, plane);
      return matrix && inverse ? {profile, width, height, corners, matrix, inverse} : null;
    }

    getRenderedPreviewRect() {
      const geometry = this.getSurfaceGeometry();
      if (geometry) return {width: geometry.width, height: geometry.height};
      const rect = this.previewSurface?.getBoundingClientRect();
      return {
        width: Math.max(1, rect?.width || 1),
        height: Math.max(1, rect?.height || 1),
      };
    }

    getSurfacePointer(clientX, clientY) {
      const geometry = this.getSurfaceGeometry();
      if (!geometry) return {x: clientX, y: clientY};
      const rect = this.getRenderedImageRect();
      return projectSurfacePoint(geometry.inverse, clientX - rect.left, clientY - rect.top);
    }

    getSurfacePlacement() {
      const geometry = this.getSurfaceGeometry();
      if (!geometry) return null;
      return {profile: geometry.profile.id || 'magsafe-holder-2026', view: geometry.profile.view,
        corners: geometry.profile.corners.map(([x, y]) => [x / geometry.profile.width, y / geometry.profile.height]),
        plane: {width: geometry.width, height: geometry.height,
          ...(geometry.profile.id === 'google-pixel-case-2026' ? {fontScale: this.getSurfaceFontScale()} : {})},
        coordinateSpace: 'unprojected-surface-css-pixels'};
    }

    getSurfaceFontScale() {
      return this.getSurfaceProfile()?.id === 'google-pixel-case-2026'
        ? this.getRenderedImageRect().width / 550 : 1;
    }

    getSurfaceTextLines(text = this.state.text.content.trim()) {
      const preset = TEXT_FONT_PRESETS[this.state.text.fontKey] || TEXT_FONT_PRESETS['classic-serif'];
      const size = this.state.text.size * this.getSurfaceFontScale() * Number(preset.sizeMultiplier || 1);
      const context = getTextMeasurementContext();
      context.font = `${preset.weight} ${size}px ${preset.family}`;
      const maxWidth = this.state.frame.enabled ? Infinity : this.getRenderedPreviewRect().width * 0.76;
      const spacing = size * Number(preset.letterSpacing || 0);
      const nativeSpacing = 'letterSpacing' in context;
      if (nativeSpacing) { context.letterSpacing = `${spacing}px`; context.fontKerning = 'none'; }
      const textWidth = (value) => nativeSpacing ? context.measureText(value).width : measureSpacedTextWidth(context, value, spacing);
      const lines = [];
      for (const paragraph of text.split(/\r?\n/)) {
        let line = '';
        for (const word of paragraph.trim().split(/\s+/).filter(Boolean)) {
          const candidate = line ? `${line} ${word}` : word;
          if (textWidth(candidate) <= maxWidth) {
            line = candidate;
            continue;
          }
          if (line) { lines.push(line); line = ''; }
          for (const character of Array.from(word)) {
            if (line && textWidth(line + character) > maxWidth) {
              lines.push(line);
              line = '';
            }
            line += character;
          }
        }
        lines.push(line);
      }
      return lines;
    }

    applySurfacePreview() {
      const geometry = this.getSurfaceGeometry();
      const layer = this.textLayer;
      for (const name of ['inset', 'left', 'top', 'width', 'height', 'transform', 'transform-origin', 'pointer-events']) {
        layer.style.removeProperty(name);
      }
      delete layer.dataset.perspectiveView;
      if (!geometry) return;
      const imageRect = this.getRenderedImageRect();
      const surfaceRect = this.previewSurface.getBoundingClientRect();
      layer.style.inset = 'auto';
      layer.style.left = `${imageRect.left - surfaceRect.left - this.previewSurface.clientLeft}px`;
      layer.style.top = `${imageRect.top - surfaceRect.top - this.previewSurface.clientTop}px`;
      layer.style.width = `${geometry.width}px`;
      layer.style.height = `${geometry.height}px`;
      layer.style.transformOrigin = '0 0';
      layer.style.transform = surfaceCssMatrix(geometry.matrix);
      layer.style.pointerEvents = 'none';
      layer.dataset.perspectiveView = String(geometry.profile.view);
    }

    async drawTextLayer(context, targetRect, renderRect, options = {}) {
      const text = options.previewOnly ? this.getPreviewText() : this.state.text.content.trim();
      if (!text) return;

      const geometry = !options.flatSurface && this.getSurfaceGeometry(targetRect);
      if (geometry) {
        const layer = document.createElement('canvas');
        layer.width = Math.max(1, Math.round(geometry.width));
        layer.height = Math.max(1, Math.round(geometry.height));
        await this.drawTextLayer(layer.getContext('2d'), {x: 0, y: 0, width: layer.width, height: layer.height},
          renderRect, {...options, flatSurface: true});
        drawSurfaceCanvas(context, layer, geometry.corners, targetRect);
        return;
      }

      const fontPreset = TEXT_FONT_PRESETS[this.state.text.fontKey] || TEXT_FONT_PRESETS["classic-serif"];

      const anchorPreset = this.getActiveTextAnchorPreset();
      const exportScaleX = targetRect.width / renderRect.width;
      const exportScaleY = targetRect.height / renderRect.height;
      const sizeMultiplier = Number(fontPreset.sizeMultiplier || 1);
      const textScale = Math.max(0.2, this.state.textTransform.scale || 1);
      const baseFontSize = Math.max(18, this.state.text.size * this.getSurfaceFontScale() * exportScaleY * sizeMultiplier);
      const fontSize = this.state.frame.enabled ? Math.max(10, baseFontSize * textScale) : baseFontSize * textScale;
      const anchorPoint = {
        x: targetRect.x + targetRect.width * anchorPreset.x + this.state.textTransform.x * exportScaleX,
        y:
          targetRect.y +
          targetRect.height * anchorPreset.y +
          this.state.textTransform.y * exportScaleY +
          targetRect.height * (options.flatSurface ? 0 : Number(fontPreset.canvasYOffset || 0)),
      };
      const textBox = {
        width: targetRect.width * 0.76,
        height: targetRect.height * 0.72,
      };

      await this.ensureFontForCanvas(fontPreset, fontSize);

      if (this.state.frame.enabled) {
        const frameAnchorPreset = this.getFramePositionPreset();
        context.save();
        context.translate(
          targetRect.x + targetRect.width * frameAnchorPreset.x,
          targetRect.y + targetRect.height * frameAnchorPreset.y,
        );
        this.drawTextFrame(context, {
          shape: this.state.frame.shape,
          frameSize: this.getFixedFrameSize(this.state.frame.shape, targetRect),
        });
        context.restore();
      }

      context.save();
      context.translate(anchorPoint.x, anchorPoint.y);
      context.rotate((this.state.textTransform.rotation * Math.PI) / 180);
      context.textAlign = anchorPreset.textAlign;
      context.textBaseline = "alphabetic";
      context.font = `${fontPreset.weight} ${fontSize}px ${fontPreset.family}`;
      const lineHeight = fontSize * Number(fontPreset.lineHeight || 1.08);
      const lines = options.flatSurface ? this.getSurfaceTextLines(text) : wrapTextLines(context, text, textBox.width);
      if (!lines.length) {
        context.restore();
        return;
      }
      const textBlockHeight = lines.length * lineHeight;
      const letterSpacing = fontSize * Number(fontPreset.letterSpacing || 0);
      let startY = -textBox.height / 2 + fontSize;

      if (anchorPreset.alignItems === "center") {
        const metrics = options.flatSurface ? context.measureText('Mg') : null;
        const baseline = Number.isFinite(metrics?.fontBoundingBoxAscent) && Number.isFinite(metrics?.fontBoundingBoxDescent)
          ? (metrics.fontBoundingBoxAscent - metrics.fontBoundingBoxDescent) / 2
          : fontSize * 0.82 - lineHeight / 2;
        startY = -(lines.length - 1) * lineHeight / 2 + baseline;
      }

      context.fillStyle = options.color || this.state.text.color;
      const nativeSpacing = options.flatSurface && 'letterSpacing' in context;
      if (nativeSpacing) { context.letterSpacing = `${letterSpacing}px`; context.fontKerning = 'none'; }
      for (const [index, line] of lines.entries()) {
        if (nativeSpacing) context.fillText(line, 0, startY + index * lineHeight);
        else drawSpacedText(context, line, 0, startY + index * lineHeight, letterSpacing);
      }

      context.restore();
    }

    drawTextFrame(context, metrics) {
      const frameSize = metrics.frameSize || this.getFixedFrameSize(metrics.shape);
      const lineWidth = Math.max(2, Math.min(frameSize.width, frameSize.height) * 0.018);
      const lineGap = lineWidth * 2.15;

      context.save();
      context.fillStyle = this.state.frame.fillColor || DEFAULT_FRAME_FILL_COLOR;
      context.strokeStyle = this.state.frame.borderColor || DEFAULT_FRAME_BORDER_COLOR;
      context.lineWidth = lineWidth;
      context.lineJoin = "round";
      context.lineCap = "round";

      traceTextFrameShape(context, metrics.shape, frameSize.width, frameSize.height, 0);
      context.fill();
      context.stroke();
      traceTextFrameShape(context, metrics.shape, frameSize.width, frameSize.height, lineGap);
      context.stroke();
      context.restore();
    }

    getFixedFrameSize(shape = "oval", bounds = null) {
      const renderedBounds = bounds || this.getRenderedPreviewRect();
      const availableWidth = Math.max(1, renderedBounds.width || 1);
      const availableHeight = Math.max(1, renderedBounds.height || availableWidth * 1.38);
      const normalizedShape = FIXED_FRAME_SIZES[shape] ? shape : "oval";
      const config = FIXED_FRAME_SIZES[normalizedShape];
      const maxFrameWidth = availableWidth * 0.64;
      const maxFrameHeight = availableHeight * 0.32;
      const frameWidth = Math.min(maxFrameWidth, Math.max(availableWidth * config.widthRatio, availableWidth * 0.34));
      const frameHeight = Math.min(maxFrameHeight, Math.max(availableWidth * config.heightRatio, availableWidth * 0.14));

      if (normalizedShape === "round") {
        const diameter = Math.min(frameWidth, frameHeight);
        return {width: diameter, height: diameter};
      }

      return {
        width: frameWidth,
        height: frameHeight,
      };
    }

    async ensureFontForCanvas(fontPreset, fontSize) {
      if (!document.fonts?.load) {
        return;
      }

      try {
        await document.fonts.load(`${fontPreset.weight} ${fontSize}px ${fontPreset.family}`);
      } catch {
        // Fall back to default browser fonts if Google Fonts fail to load.
      }
    }

    buildDesignFilename() {
      return `${slugify(this.root.dataset.productTitle || "personalized-case")}-text-${Date.now()}.png`;
    }

    resolvePreviewImageUrl() {
      return (
        this.state.previewImageUrl ||
        this.root.dataset.previewImage ||
        this.previewImage?.currentSrc ||
        this.previewImage?.src ||
        this.fallbackPreviewImageUrl ||
        ""
      );
    }

    render() {
      this.syncTextPlacementBounds();
      this.renderControlVisibility();
      this.renderFontControlStyling();
      this.renderTextOverlay();
      this.syncHiddenFields();
      void this.applyAutomaticTextColor();
    }

    drawAutomaticColorSample(context, bounds) {
      const geometry = this.getSurfaceGeometry(bounds);
      const anchor = this.getActiveTextAnchorPreset();
      const width = geometry ? geometry.width : bounds.width;
      const height = geometry ? geometry.height : bounds.height;
      const halfWidth = width * (geometry ? 0.25 : 0.14);
      const halfHeight = height * (geometry ? 0.06 : 0.045);
      const preview = this.getRenderedPreviewRect();
      const centerX = width * (anchor.x + this.state.textTransform.x / Math.max(1, preview.width));
      const centerY = height * (anchor.y + this.state.textTransform.y / Math.max(1, preview.height));
      const corners = [[centerX - halfWidth, centerY - halfHeight], [centerX + halfWidth, centerY - halfHeight],
        [centerX + halfWidth, centerY + halfHeight], [centerX - halfWidth, centerY + halfHeight]];
      context.fillStyle = "#FFFFFF";
      context.beginPath();
      corners.forEach(([x, y], index) => {
        const point = geometry ? projectSurfacePoint(geometry.matrix, x, y) : {x: x + bounds.x, y: y + bounds.y};
        if (index === 0) context.moveTo(point.x, point.y);
        else context.lineTo(point.x, point.y);
      });
      context.closePath();
      context.fill();
    }

    async applyAutomaticTextColor() {
      if (!this.autoColorEnabled || this.colorManuallyChosen || !this.state.enabled ||
          this.state.frame.enabled || this.state.uploadingDesign || this.textGesture) return;
      const url = this.resolvePreviewImageUrl();
      if (!url) return;
      const bounds = this.getRenderedPreviewRect();
      const key = JSON.stringify([url, this.state.text.anchor,
        Number((this.state.textTransform.x / Math.max(1, bounds.width)).toFixed(4)),
        Number((this.state.textTransform.y / Math.max(1, bounds.height)).toFixed(4))]);
      if (this.autoColorKey === key) return;
      this.autoColorKey = key;
      const request = ++this.autoColorRequest;
      let timer;
      try {
        await new Promise(resolve => setTimeout(resolve, 120));
        if (request !== this.autoColorRequest || this.colorManuallyChosen || !this.state.enabled) return;
        const image = await Promise.race([
          loadImage(url),
          new Promise((_, reject) => { timer = setTimeout(() => reject(new Error("Color analysis timeout")), 5000); }),
        ]);
        const canvas = document.createElement("canvas");
        const scale = Math.min(1, 900 / Math.max(image.naturalWidth, image.naturalHeight));
        canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
        canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
        const context = canvas.getContext("2d", {willReadFrequently: true});
        if (!context) return;
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        const mask = document.createElement("canvas");
        mask.width = canvas.width;
        mask.height = canvas.height;
        const maskContext = mask.getContext("2d", {willReadFrequently: true});
        if (!maskContext) return;
        this.drawAutomaticColorSample(maskContext, {x: 0, y: 0, width: mask.width, height: mask.height});
        if (request !== this.autoColorRequest || this.colorManuallyChosen) return;
        const assessment = [];
        const color = chooseReadableTextColor(context.getImageData(0, 0, canvas.width, canvas.height).data,
          maskContext.getImageData(0, 0, mask.width, mask.height).data, assessment, {width: canvas.width, height: canvas.height});
        if (!color || request !== this.autoColorRequest || this.colorManuallyChosen ||
            !this.state.enabled || this.state.frame.enabled || this.state.uploadingDesign ||
            this.resolvePreviewImageUrl() !== url) return;
        this.state.text.color = color;
        if (this.textColorInput) this.textColorInput.value = color;
        this.root.dataset.autoColorState = "applied";
        this.root.dataset.autoColorAssessment = JSON.stringify(assessment);
        this.markDesignDirty();
        this.render();
      } catch {
        // Image loading/CORS/canvas failure leaves the existing editable color.
        if (request === this.autoColorRequest) this.root.dataset.autoColorState = "fallback";
      } finally {
        clearTimeout(timer);
      }
    }

    renderControlVisibility() {
      if (this.controls) {
        this.controls.hidden = !this.state.enabled;
      }
      if (this.frameOptions) {
        this.frameOptions.hidden = !this.state.frame.enabled;
      }
      if (this.framePositionField) {
        this.framePositionField.hidden = !this.state.frame.enabled;
      }
    }

    renderFontControlStyling() {
      const fontPreset = TEXT_FONT_PRESETS[this.state.text.fontKey] || TEXT_FONT_PRESETS["classic-serif"];
      if (this.textFontInput) {
        this.textFontInput.style.fontFamily = fontPreset.family;
        this.textFontInput.style.fontWeight = fontPreset.weight;
      }
    }

    renderTextOverlay() {
      if (!this.textLayer) return;

      this.textLayer.innerHTML = "";
      this.applySurfacePreview();

      if (!this.state.enabled || !this.getPreviewText()) {
        return;
      }

      const anchorPreset = this.getActiveTextAnchorPreset();
      const fontPreset = TEXT_FONT_PRESETS[this.state.text.fontKey] || TEXT_FONT_PRESETS["classic-serif"];
      const textContent = this.getPreviewText();
      const frameMetrics = this.state.frame.enabled
        ? this.getPreviewFrameMetrics()
        : null;
      const textEditor = document.createElement("div");
      textEditor.className = "product-text-personalizer__text-editor";
      textEditor.dataset.textEditor = "true";
      textEditor.tabIndex = 0;
      if (this.positionHint) textEditor.setAttribute("aria-label", this.positionHint);
      textEditor.addEventListener("keydown", (event) => {
        const directions = {ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1]};
        if (!directions[event.key] || event.target !== textEditor) return;
        event.preventDefault();
        this.nudgeText(...directions[event.key], event.shiftKey ? 3 : 1);
        this.textLayer.querySelector("[data-text-editor]")?.focus({preventScroll: true});
      });
      if (this.state.frame.enabled) {
        const frameAnchorPreset = this.getFramePositionPreset();
        const frameElement = document.createElement("div");
        frameElement.className = "product-text-personalizer__fixed-frame";
        frameElement.style.left = `${frameAnchorPreset.x * 100}%`;
        frameElement.style.top = `${frameAnchorPreset.y * 100}%`;
        this.applyPreviewFrameSize(frameElement, frameMetrics.frame);
        frameElement.appendChild(this.buildFrameSvg(frameMetrics.frame));
        this.textLayer.appendChild(frameElement);
        textEditor.classList.add("product-text-personalizer__text-editor--frame-text");
      }
      textEditor.style.left = `${anchorPreset.x * 100}%`;
      textEditor.style.top = `${anchorPreset.y * 100}%`;
      textEditor.style.setProperty("--text-origin-x", this.getTextOriginX(anchorPreset.textAlign));
      textEditor.style.setProperty("--text-origin-y", this.getTextOriginY(anchorPreset.alignItems));
      textEditor.style.setProperty("--text-offset-x", `${this.state.textTransform.x}px`);
      textEditor.style.setProperty("--text-offset-y", `${this.state.textTransform.y}px`);
      textEditor.style.setProperty("--text-editor-scale", String(this.state.textTransform.scale));
      textEditor.style.setProperty("--text-rotation", `${this.state.textTransform.rotation}deg`);
      textEditor.addEventListener("pointerdown", (event) => this.startTextGesture(event, "move"));

      const textHitArea = document.createElement("span");
      textHitArea.className = "product-text-personalizer__text-hit-area";
      textHitArea.setAttribute("aria-hidden", "true");

      const textNode = document.createElement("div");
      textNode.className = "product-text-personalizer__text";
      textNode.textContent = textContent;
      textNode.style.color = this.state.text.color;
      textNode.style.fontFamily = fontPreset.family;
      textNode.style.fontStyle = "normal";
      textNode.style.fontWeight = fontPreset.weight;
      const sizeMultiplier = this.getSurfaceProfile() ? Number(fontPreset.sizeMultiplier || 1) : 1;
      textNode.style.fontSize = `${this.state.text.size * this.getSurfaceFontScale() * sizeMultiplier}px`;
      if (this.getSurfaceProfile()) {
        textEditor.style.width = 'max-content';
        textNode.style.textShadow = 'none';
        textNode.style.fontKerning = 'none';
        textEditor.style.maxWidth = 'none';
        textNode.style.maxWidth = 'none';
        textNode.style.overflowWrap = 'normal';
        textNode.style.whiteSpace = 'pre';
        textNode.textContent = this.getSurfaceTextLines(textContent).join('\n');
      }
      textNode.style.lineHeight = String(fontPreset.lineHeight || 1.08);
      textNode.style.letterSpacing = `${Number(fontPreset.letterSpacing || 0).toFixed(3)}em`;
      textNode.style.textAlign = anchorPreset.textAlign;

      const scaleHandle = document.createElement("button");
      scaleHandle.type = "button";
      scaleHandle.className =
        "product-text-personalizer__text-handle product-text-personalizer__text-handle--scale";
      scaleHandle.setAttribute("aria-label", "Resize text");
      scaleHandle.addEventListener("pointerdown", (event) => this.startTextGesture(event, "scale"));

      const rotateHandle = document.createElement("button");
      rotateHandle.type = "button";
      rotateHandle.className =
        "product-text-personalizer__text-handle product-text-personalizer__text-handle--rotate";
      rotateHandle.setAttribute("aria-label", "Rotate text");
      rotateHandle.addEventListener("pointerdown", (event) => this.startTextGesture(event, "rotate"));

      textEditor.appendChild(textHitArea);
      textEditor.appendChild(textNode);
      textEditor.appendChild(scaleHandle);
      textEditor.appendChild(rotateHandle);
      this.textLayer.appendChild(textEditor);
    }

    getPreviewFrameMetrics() {
      return {
        frame: this.getFixedFrameSize(this.state.frame.shape, this.getRenderedPreviewRect()),
      };
    }

    applyPreviewFrameSize(textEditor, frameSize) {
      textEditor.style.setProperty("--frame-width", `${frameSize.width}px`);
      textEditor.style.setProperty("--frame-height", `${frameSize.height}px`);
      textEditor.style.setProperty("--frame-half-width", `${frameSize.width / 2}px`);
      textEditor.style.setProperty("--frame-half-height", `${frameSize.height / 2}px`);

      const frameSvg = textEditor.querySelector(".product-text-personalizer__text-frame");
      if (frameSvg) {
        frameSvg.style.width = `${frameSize.width}px`;
        frameSvg.style.height = `${frameSize.height}px`;
      }
    }

    buildFrameSvg(frameSize) {
      const shape = this.state.frame.shape || "oval";
      const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.classList.add("product-text-personalizer__text-frame");
      svg.classList.add(`product-text-personalizer__text-frame--${shape}`);
      svg.setAttribute("aria-hidden", "true");
      svg.setAttribute("focusable", "false");
      if (frameSize) {
        svg.style.width = `${frameSize.width}px`;
        svg.style.height = `${frameSize.height}px`;
      }
      svg.style.setProperty("--frame-line-color", this.state.frame.borderColor || DEFAULT_FRAME_BORDER_COLOR);
      svg.style.setProperty("--frame-fill-color", this.state.frame.fillColor || DEFAULT_FRAME_FILL_COLOR);

      if (shape === "round") {
        svg.setAttribute("viewBox", "0 0 220 220");
        appendSvgShape(svg, "circle", {cx: 110, cy: 110, r: 102}, true);
        appendSvgShape(svg, "circle", {cx: 110, cy: 110, r: 91}, false);
        return svg;
      }

      if (shape === "label") {
        svg.setAttribute("viewBox", "0 0 320 150");
        appendSvgShape(svg, "path", {
          d: "M26 11H294C294 35 308 44 318 46V104C308 106 294 115 294 139H26C26 115 12 106 2 104V46C12 44 26 35 26 11Z",
        }, true);
        appendSvgShape(svg, "path", {
          d: "M35 21H285C285 39 298 55 309 57V93C298 95 285 111 285 129H35C35 111 22 95 11 93V57C22 55 35 39 35 21Z",
        }, false);
        return svg;
      }

      svg.setAttribute("viewBox", "0 0 320 190");
      appendSvgShape(svg, "ellipse", {cx: 160, cy: 95, rx: 150, ry: 76}, true);
      appendSvgShape(svg, "ellipse", {cx: 160, cy: 95, rx: 140, ry: 66}, false);
      return svg;
    }

    getTextOriginX(textAlign) {
      if (textAlign === "left") return "0%";
      if (textAlign === "right") return "-100%";
      return "-50%";
    }

    normalizeFramePosition(position) {
      return FRAME_POSITION_PRESETS[position] ? position : "center";
    }

    getFramePositionPreset() {
      const position = this.normalizeFramePosition(this.state.frame.position);
      const profile = this.getSurfaceProfile();
      if (position === "bottom" && profile) return profile.nameAnchor || HOLDER_NAME_ANCHOR;
      return FRAME_POSITION_PRESETS[position] || FRAME_POSITION_PRESETS.center;
    }

    getActiveTextAnchorPreset() {
      if (this.state.frame.enabled) {
        return this.getFramePositionPreset();
      }

      const profile = this.getSurfaceProfile();
      if (this.state.text.anchor === "bottom" && profile) return profile.nameAnchor || HOLDER_NAME_ANCHOR;
      return TEXT_ANCHOR_PRESETS[this.state.text.anchor] || TEXT_ANCHOR_PRESETS.center;
    }

    getTextOriginY(alignItems) {
      if (alignItems === "flex-start") return "0%";
      if (alignItems === "flex-end") return "-100%";
      return "-50%";
    }

    resetTextPlacement(options = {}) {
      const {resetScale = false, resetRotation = false} = options;
      this.state.text.anchor = this.defaultTextAnchor;
      if (this.getSurfaceProfile()) {
        this.state.frame.position = "bottom";
        if (this.framePositionInput) this.framePositionInput.value = "bottom";
      }
      this.state.textTransform.x = 0;
      this.state.textTransform.y = 0;
      if (resetScale) {
        this.state.textTransform.scale = 1;
      }
      if (resetRotation) {
        this.state.textTransform.rotation = 0;
      }
    }

    setupTextPositionControls() {
      const template = this.getScope().querySelector("[data-name-position-controls]");
      if (!template || !this.controls || this.controls.querySelector("[data-name-position-panel]")) return;
      this.controls.appendChild(template.content.cloneNode(true));
      const panel = this.controls.querySelector("[data-name-position-panel]");
      this.positionHint = panel.dataset.positionHint;
      panel.querySelectorAll("[data-name-nudge]").forEach(button => {
        button.addEventListener("click", () => {
          const [x, y] = button.dataset.nameNudge.split(",").map(Number);
          this.nudgeText(x, y);
        });
      });
      panel.querySelector("[data-name-reset]").addEventListener("click", () => {
        this.resetTextPlacement({resetScale: true, resetRotation: true});
        this.markDesignDirty();
        this.render();
      });
    }

    syncTextPlacementBounds() {
      const bounds = this.getRenderedPreviewRect();
      if (!bounds?.width || !bounds?.height) return;
      const previous = this.placementBounds;
      if (previous) {
        this.state.textTransform.x *= bounds.width / previous.width;
        this.state.textTransform.y *= bounds.height / previous.height;
      }
      this.placementBounds = {width: bounds.width, height: bounds.height};
    }

    setTextPosition(x, y) {
      const bounds = this.getRenderedPreviewRect();
      const anchor = this.getActiveTextAnchorPreset();
      const profile = this.getSurfaceProfile();
      const preset = TEXT_FONT_PRESETS[this.state.text.fontKey] || TEXT_FONT_PRESETS["classic-serif"];
      const context = document.createElement("canvas").getContext("2d");
      const size = this.state.text.size * this.getSurfaceFontScale() * (profile ? Number(preset.sizeMultiplier || 1) : 1);
      context.font = `${preset.weight} ${size}px ${preset.family}`;
      const lines = profile ? this.getSurfaceTextLines(this.getPreviewText()) : [this.getPreviewText()];
      const textWidth = Math.max(...lines.map(line => measureSpacedTextWidth(context, line, size * Number(preset.letterSpacing || 0))));
      const textHeight = size * Number(preset.lineHeight || 1.08) * lines.length;
      const angle = this.state.textTransform.rotation * Math.PI / 180;
      const scale = this.state.textTransform.scale;
      const halfWidth = Math.min(bounds.width * 0.42, (Math.abs(Math.cos(angle)) * textWidth + Math.abs(Math.sin(angle)) * textHeight) * scale / 2);
      const halfHeight = Math.min(bounds.height * 0.35, (Math.abs(Math.sin(angle)) * textWidth + Math.abs(Math.cos(angle)) * textHeight) * scale / 2);
      const marginX = bounds.width * 0.06, marginY = bounds.height * 0.06;
      this.state.textTransform.x = clamp(x, marginX + halfWidth - bounds.width * anchor.x, bounds.width - marginX - halfWidth - bounds.width * anchor.x);
      this.state.textTransform.y = clamp(y, marginY + halfHeight - bounds.height * anchor.y, bounds.height * (profile ? 0.90 : 0.94) - halfHeight - bounds.height * anchor.y);
    }

    nudgeText(x, y, multiplier = 1) {
      if (!this.state.enabled || !this.getPreviewText()) return;
      const bounds = this.getRenderedPreviewRect();
      this.setTextPosition(this.state.textTransform.x + x * bounds.width * 0.015 * multiplier,
        this.state.textTransform.y + y * bounds.height * 0.015 * multiplier);
      this.markDesignDirty();
      this.render();
    }

    startTextGesture(event, type) {
      if (!this.state.enabled || !this.getPreviewText() || (event.pointerType === "mouse" && event.button !== 0)) return;
      const editor = event.currentTarget?.closest("[data-text-editor]");
      if (!editor) return;

      if (event.pointerType === "touch" && event.isPrimary) {
        this.textPointers.clear();
        this.textGesture = null;
      }

      this.autoColorRequest += 1;
      this.autoColorKey = "";
      this.previewSurface?.setPointerCapture?.(event.pointerId);
      this.textPointers.set(event.pointerId, this.getSurfacePointer(event.clientX, event.clientY));

      if (event.pointerType === "touch" && type === "move" && this.textPointers.size >= 2) {
        this.textGesture = this.createMultiPointerGesture(this.textPointers, this.state.textTransform);
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      const rect = editor.getBoundingClientRect();
      const point = this.getSurfacePointer(event.clientX, event.clientY);
      const geometry = this.getSurfaceGeometry();
      const anchor = this.getActiveTextAnchorPreset();
      const centerX = geometry ? geometry.width * anchor.x + this.state.textTransform.x : rect.left + rect.width / 2;
      const centerY = geometry ? geometry.height * anchor.y + this.state.textTransform.y : rect.top + rect.height / 2;

      this.textGesture = {
        type,
        pointerId: event.pointerId,
        startClientX: point.x,
        startClientY: point.y,
        startX: this.state.textTransform.x,
        startY: this.state.textTransform.y,
        startScale: this.state.textTransform.scale,
        startRotation: this.state.textTransform.rotation,
        centerX,
        centerY,
        startDistance: Math.max(1, Math.hypot(point.x - centerX, point.y - centerY)),
        startAngle: Math.atan2(point.y - centerY, point.x - centerX),
      };

      event.preventDefault();
      event.stopPropagation();
    }

    handleTextGestureMove(event) {
      if (this.textPointers.has(event.pointerId)) {
        this.textPointers.set(event.pointerId, this.getSurfacePointer(event.clientX, event.clientY));
      }

      if (!this.textGesture || event.pointerId !== this.textGesture.pointerId) {
        if (this.textGesture?.type !== "pinch") {
          return;
        }
      }

      if (this.textGesture.type === "pinch") {
        const pinchPointers = this.getGesturePointerPair(this.textPointers, this.textGesture.pointerIds);
        if (!pinchPointers) return;

        const midpointX = (pinchPointers.first.x + pinchPointers.second.x) / 2;
        const midpointY = (pinchPointers.first.y + pinchPointers.second.y) / 2;
        const nextDistance = Math.max(
          1,
          Math.hypot(
            pinchPointers.second.x - pinchPointers.first.x,
            pinchPointers.second.y - pinchPointers.first.y,
          ),
        );
        const nextAngle = Math.atan2(
          pinchPointers.second.y - pinchPointers.first.y,
          pinchPointers.second.x - pinchPointers.first.x,
        );
        const distanceRatio = nextDistance / this.textGesture.startDistance;
        const deltaAngle = ((nextAngle - this.textGesture.startAngle) * 180) / Math.PI;

        this.setTextPosition(this.textGesture.startX + (midpointX - this.textGesture.startMidpointX),
          this.textGesture.startY + (midpointY - this.textGesture.startMidpointY));
        this.state.textTransform.scale = Number(
          clamp(this.textGesture.startScale * distanceRatio, 0.45, 3.5).toFixed(3),
        );
        this.state.textTransform.rotation = Number((this.textGesture.startRotation + deltaAngle).toFixed(2));

        this.markDesignDirty();
        this.render();
        event.preventDefault();
        return;
      }

      const gesture = this.textGesture;
      const point = this.getSurfacePointer(event.clientX, event.clientY);
      const deltaX = point.x - gesture.startClientX;
      const deltaY = point.y - gesture.startClientY;

      if (gesture.type === "move") {
        this.setTextPosition(gesture.startX + deltaX, gesture.startY + deltaY);
      }

      if (gesture.type === "scale") {
        const nextDistance = Math.max(
          1,
          Math.hypot(point.x - gesture.centerX, point.y - gesture.centerY),
        );
        const distanceRatio = nextDistance / gesture.startDistance;
        this.state.textTransform.scale = Number(
          clamp(gesture.startScale * distanceRatio, 0.45, 3.5).toFixed(3),
        );
      }

      if (gesture.type === "rotate") {
        const nextAngle = Math.atan2(point.y - gesture.centerY, point.x - gesture.centerX);
        const deltaAngle = ((nextAngle - gesture.startAngle) * 180) / Math.PI;
        this.state.textTransform.rotation = Number((gesture.startRotation + deltaAngle).toFixed(2));
      }

      this.markDesignDirty();
      this.render();
      event.preventDefault();
    }

    finishTextGesture(event) {
      if (event?.pointerId !== undefined) {
        this.textPointers.delete(event.pointerId);
        if (this.previewSurface?.hasPointerCapture?.(event.pointerId)) this.previewSurface.releasePointerCapture(event.pointerId);
      }

      if (!this.textGesture) return;

      if (this.textGesture.type === "pinch") {
        if (this.textPointers.size < 2) {
          this.textPointers.clear();
          this.textGesture = null;
          this.render();
        }
        return;
      }

      if (event && event.pointerId !== undefined && event.pointerId !== this.textGesture.pointerId) {
        return;
      }
      this.textGesture = null;
      this.render();
    }

    createMultiPointerGesture(pointerMap, transformState) {
      const pair = this.getGesturePointerPair(pointerMap);
      if (!pair) return null;

      const midpointX = (pair.first.x + pair.second.x) / 2;
      const midpointY = (pair.first.y + pair.second.y) / 2;
      const startAngle = Math.atan2(pair.second.y - pair.first.y, pair.second.x - pair.first.x);

      return {
        type: "pinch",
        pointerIds: pair.pointerIds,
        startX: transformState.x,
        startY: transformState.y,
        startScale: transformState.scale,
        startRotation: Number(transformState.rotation || 0),
        startAngle,
        startMidpointX: midpointX,
        startMidpointY: midpointY,
        startDistance: Math.max(
          1,
          Math.hypot(pair.second.x - pair.first.x, pair.second.y - pair.first.y),
        ),
      };
    }

    getGesturePointerPair(pointerMap, preferredIds) {
      const entries = preferredIds?.length
        ? preferredIds.map((id) => [id, pointerMap.get(id)]).filter(([, value]) => Boolean(value))
        : Array.from(pointerMap.entries()).sort((first, second) => first[0] - second[0]).slice(0, 2);

      if (entries.length < 2) return null;

      return {
        pointerIds: [entries[0][0], entries[1][0]],
        first: entries[0][1],
        second: entries[1][1],
      };
    }

    syncHiddenFields() {
      const transformPayload = this.state.enabled
        ? JSON.stringify({
            mode: "text_only_optional",
            text: this.state.text,
            frame: this.state.frame,
            textTransform: this.state.textTransform,
            surface: this.getSurfacePlacement(),
          })
        : "";
      const textPayload = this.state.enabled
        ? JSON.stringify({
            ...this.state.text,
            frame: this.state.frame,
            transform: this.state.textTransform,
            previewImageUrl: this.resolvePreviewImageUrl() || null,
            surface: this.getSurfacePlacement(),
          })
        : "";

      this.refreshForms();

      for (const form of this.forms) {
        this.ensureHiddenField(form, "properties[_custom_image_url]").value =
          this.state.enabled ? this.state.fileUrl || "" : "";
        this.ensureHiddenField(form, "properties[_custom_image_file_id]").value =
          this.state.enabled ? this.state.fileId || "" : "";
        this.ensureHiddenField(form, "properties[_custom_original_image_url]").value = "";
        this.ensureHiddenField(form, "properties[_custom_original_image_file_id]").value = "";
        this.ensureHiddenField(form, "properties[_custom_preview_image_url]").value =
          this.state.enabled ? this.state.fileUrl || "" : "";
        this.ensureHiddenField(form, "properties[_custom_preview_image_file_id]").value =
          this.state.enabled ? this.state.fileId || "" : "";
        this.ensureHiddenField(form, "properties[_custom_transform_json]").value = transformPayload;
        this.ensureHiddenField(form, "properties[_custom_text_json]").value = textPayload;
        this.ensureHiddenField(form, "properties[_customization_mode]").value =
          this.state.enabled ? "text_only_optional" : "";
        this.ensureHiddenField(form, "properties[_customization_version]").value =
          this.state.enabled ? CUSTOMIZATION_VERSION : "";
        this.ensureHiddenField(form, "properties[Customization]").value = this.getCustomizationLabel();
        form.querySelectorAll('[name="properties[Text frame]"]').forEach((field) => field.remove());
      }
    }

    getCustomizationLabel() {
      if (!this.hasActiveCustomization()) {
        return "";
      }
      return this.state.frame.enabled ? "Custom text with frame" : "Custom text";
    }

    getTextFrameLabel() {
      if (!this.hasActiveCustomization() || !this.state.frame.enabled) {
        return "";
      }

      const shapeLabels = {
        round: "Round",
        oval: "Oval",
        label: "Decorative label",
      };
      const positionLabels = {
        center: "Center",
        bottom: "Bottom center",
      };

      return `${shapeLabels[this.state.frame.shape] || "Oval"} / ${positionLabels[this.normalizeFramePosition(this.state.frame.position)]} / line ${this.state.frame.borderColor} / fill ${this.state.frame.fillColor}`;
    }

    ensureHiddenField(form, name) {
      let field = Array.from(form.querySelectorAll('input[type="hidden"]')).find((input) => input.name === name);
      if (!field) {
        field = document.createElement("input");
        field.type = "hidden";
        field.name = name;
        form.appendChild(field);
      }

      field.disabled = !this.state.enabled;
      return field;
    }

    async uploadFile(file) {
      const stagedTarget = await this.prepareUpload(file);
      await this.uploadToStagedTarget(stagedTarget, file);
      return this.finalizeUpload(stagedTarget.resourceUrl, file.name);
    }

    async prepareUpload(file) {
      const endpoint = new URL(this.buildUploadUrl(), window.location.origin);
      endpoint.searchParams.set("operation", "prepare");
      endpoint.searchParams.set("filename", file.name);
      endpoint.searchParams.set("mimeType", file.type);
      endpoint.searchParams.set("fileSize", String(file.size));

      const response = await fetch(`${endpoint.pathname}${endpoint.search}`, {
        method: "GET",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "ngrok-skip-browser-warning": "1",
        },
      });

      const payload = await this.readJsonResponse(response);
      if (payload.error || !response.ok) {
        throw new Error(payload.error || "Failed to prepare image upload.");
      }

      return payload;
    }

    async uploadToStagedTarget(stagedTarget, file) {
      const formData = new FormData();

      for (const parameter of stagedTarget.parameters || []) {
        formData.append(parameter.name, parameter.value);
      }

      formData.append("file", file);

      const response = await fetch(stagedTarget.url, {
        method: "POST",
        body: formData,
        mode: "no-cors",
      });

      if (response.type === "opaque") {
        return;
      }

      if (!response.ok) {
        throw new Error("Image upload to Shopify storage failed.");
      }
    }

    async finalizeUpload(resourceUrl, alt) {
      const endpoint = new URL(this.buildUploadUrl(), window.location.origin);
      endpoint.searchParams.set("operation", "finalize");
      endpoint.searchParams.set("resourceUrl", resourceUrl);
      endpoint.searchParams.set("alt", alt);

      const response = await fetch(`${endpoint.pathname}${endpoint.search}`, {
        method: "GET",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "ngrok-skip-browser-warning": "1",
        },
      });

      const payload = await this.readJsonResponse(response);
      if (payload.error || !response.ok) {
        throw new Error(payload.error || "Failed to finalize image upload.");
      }

      return payload;
    }

    async readJsonResponse(response) {
      const raw = await response.text();
      const contentType = response.headers.get("content-type") || "";
      const trimmed = raw.trim();

      if (trimmed.startsWith("{") || trimmed.startsWith("[")) {
        try {
          return JSON.parse(trimmed);
        } catch {
          throw new Error("Server returned invalid JSON.");
        }
      }

      if (!contentType.includes("application/json")) {
        throw new Error(`Server returned ${contentType || "a non-JSON response"} instead of JSON.`);
      }

      try {
        return trimmed ? JSON.parse(trimmed) : {};
      } catch {
        throw new Error("Server returned invalid JSON.");
      }
    }

    buildUploadUrl() {
      const rawUploadUrl = this.root.dataset.uploadUrl || "/apps/phone-case-customizer/upload";
      const uploadUrl = new URL(rawUploadUrl, window.location.origin);
      const currentParams = new URLSearchParams(window.location.search);

      for (const [key, value] of currentParams.entries()) {
        if (!uploadUrl.searchParams.has(key)) {
          uploadUrl.searchParams.set(key, value);
        }
      }

      return `${uploadUrl.pathname}${uploadUrl.search}`;
    }

    setStatus(message, state) {
      if (!this.status) return;
      this.status.textContent = message;
      this.status.dataset.state = state;
    }
  }

  let textMeasurementCanvas = null;

  function getTextMeasurementContext() {
    if (!textMeasurementCanvas) {
      textMeasurementCanvas = document.createElement("canvas");
    }

    return textMeasurementCanvas.getContext("2d");
  }

  function wrapTextLines(context, text, maxWidth) {
    const paragraphs = text
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter(Boolean);
    const lines = [];

    if (!paragraphs.length) {
      return lines;
    }

    for (const paragraph of paragraphs) {
      const words = paragraph.split(/\s+/);
      let currentLine = "";

      for (const word of words) {
        const candidate = currentLine ? `${currentLine} ${word}` : word;

        if (context.measureText(candidate).width <= maxWidth || !currentLine) {
          currentLine = candidate;
          continue;
        }

        lines.push(currentLine);
        currentLine = word;
      }

      if (currentLine) {
        lines.push(currentLine);
      }
    }

    return lines;
  }

  function appendSvgShape(svg, tagName, attributes, shouldFill) {
    const shape = document.createElementNS("http://www.w3.org/2000/svg", tagName);

    for (const [name, value] of Object.entries(attributes)) {
      shape.setAttribute(name, String(value));
    }

    shape.setAttribute("fill", shouldFill ? "var(--frame-fill-color)" : "none");
    shape.setAttribute("stroke", "var(--frame-line-color)");
    shape.setAttribute("stroke-width", "3");
    shape.setAttribute("stroke-linejoin", "round");
    shape.setAttribute("stroke-linecap", "round");
    svg.appendChild(shape);
  }

  function traceTextFrameShape(context, shape, width, height, inset) {
    const innerWidth = Math.max(1, width - inset * 2);
    const innerHeight = Math.max(1, height - inset * 2);

    if (shape === "round") {
      const radius = Math.max(1, Math.min(innerWidth, innerHeight) / 2);
      context.beginPath();
      context.ellipse(0, 0, radius, radius, 0, 0, Math.PI * 2);
      return;
    }

    if (shape === "label") {
      traceDecorativeLabelPath(context, innerWidth, innerHeight);
      return;
    }

    context.beginPath();
    context.ellipse(0, 0, innerWidth / 2, innerHeight / 2, 0, 0, Math.PI * 2);
  }

  function traceDecorativeLabelPath(context, width, height) {
    const x = -width / 2;
    const y = -height / 2;
    const w = width;
    const h = height;

    context.beginPath();
    context.moveTo(x + w * 0.081, y + h * 0.074);
    context.lineTo(x + w * 0.919, y + h * 0.074);
    context.bezierCurveTo(x + w * 0.919, y + h * 0.232, x + w * 0.963, y + h * 0.295, x + w * 0.994, y + h * 0.305);
    context.lineTo(x + w * 0.994, y + h * 0.695);
    context.bezierCurveTo(x + w * 0.963, y + h * 0.705, x + w * 0.919, y + h * 0.768, x + w * 0.919, y + h * 0.926);
    context.lineTo(x + w * 0.081, y + h * 0.926);
    context.bezierCurveTo(x + w * 0.081, y + h * 0.768, x + w * 0.037, y + h * 0.705, x + w * 0.006, y + h * 0.695);
    context.lineTo(x + w * 0.006, y + h * 0.305);
    context.bezierCurveTo(x + w * 0.037, y + h * 0.295, x + w * 0.081, y + h * 0.232, x + w * 0.081, y + h * 0.074);
    context.closePath();
  }

  function chooseReadableTextColor(pixels, mask, assessment, dimensions = {}) {
    const luminance = (r, g, b) => {
      const linear = value => { const s = value / 255; return s <= 0.04045 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4; };
      return 0.2126 * linear(r) + 0.7152 * linear(g) + 0.0722 * linear(b);
    };
    const oklab = (r, g, b) => {
      const linear = value => { const s = value / 255; return s <= 0.04045 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4; };
      r = linear(r); g = linear(g); b = linear(b);
      const l = Math.cbrt(0.4122214708 * r + 0.5363325363 * g + 0.0514459929 * b);
      const m = Math.cbrt(0.2119034982 * r + 0.6806995451 * g + 0.1073969566 * b);
      const s = Math.cbrt(0.0883024619 * r + 0.2817188376 * g + 0.6299787005 * b);
      return [0.2104542553 * l + 0.7936177850 * m - 0.0040720468 * s,
        1.9779984951 * l - 2.4285922050 * m + 0.4505937099 * s,
        0.0259040371 * l + 0.7827717662 * m - 0.8086757660 * s];
    };
    const backgrounds = [];
    const regionColors = new Map();
    let edgePairs = 0, edgeChanges = 0;
    const width = Number(dimensions.width) || 0;
    const height = Number(dimensions.height) || 0;
    let left = width, top = height, right = 0, bottom = 0;
    for (let i = 0; i < pixels.length; i += 4) {
      if (pixels[i + 3] < 128 || (mask && mask[i + 3] < 160)) continue;
      const background = luminance(pixels[i], pixels[i + 1], pixels[i + 2]);
      backgrounds.push(background);
      const bucket = (pixels[i] >> 4) * 256 + (pixels[i + 1] >> 4) * 16 + (pixels[i + 2] >> 4);
      const existing = regionColors.get(bucket);
      if (existing) existing.count++;
      else regionColors.set(bucket, {lab: oklab(pixels[i], pixels[i + 1], pixels[i + 2]), luminance: background, count: 1});
      if (width) {
        const x = (i / 4) % width;
        const step = Math.max(1, Math.round(width * 0.004));
        for (const offset of [x + step < width ? step * 4 : 0, width * step * 4]) {
          const j = i + offset;
          if (!offset || j >= pixels.length || pixels[j + 3] < 128 || (mask && mask[j + 3] < 160)) continue;
          edgePairs++;
          if (Math.abs(background - luminance(pixels[j], pixels[j + 1], pixels[j + 2])) > 0.18) edgeChanges++;
        }
      }
      if (width) {
        const x = (i / 4) % width, y = Math.floor(i / 4 / width);
        left = Math.min(left, x); right = Math.max(right, x);
        top = Math.min(top, y); bottom = Math.max(bottom, y);
      }
    }
    if (!backgrounds.length) return null;
    const palettes = {
      amber: ["#FFE1B8", "#FFF1DE", "#4A3024", "#2C201A"],
      olive: ["#E8E8CA", "#F3F2E4", "#454B31", "#282D21"],
      green: ["#DFEADB", "#F0F4EA", "#294C3D", "#1D3028"],
      teal: ["#DAECE7", "#EFF5F2", "#285055", "#172729"],
      blue: ["#E1EAF3", "#F0F4F8", "#30485F", "#1D2D40"],
      violet: ["#EBDFF0", "#F5EEF8", "#523F60", "#32263B"],
      rose: ["#F2DBE5", "#FAEDF2", "#663E52", "#402534"],
      wine: ["#F4DDDA", "#FBEFEC", "#66363A", "#3B2226"],
      neutral: ["#F1EEE9", "#FAF9F6", "#33343A", "#222327"],
    };
    const weights = Object.fromEntries(Object.keys(palettes).map(key => [key, 0]));
    let sampled = 0, chromatic = 0;
    const sample = i => {
      if (pixels[i + 3] < 128) return;
      sampled++;
      const r = pixels[i] / 255, g = pixels[i + 1] / 255, b = pixels[i + 2] / 255;
      const high = Math.max(r, g, b), low = Math.min(r, g, b), delta = high - low;
      if (delta < 0.065 || high < 0.16 || low > 0.92) return;
      let hue = high === r ? ((g - b) / delta) % 6 : high === g ? (b - r) / delta + 2 : (r - g) / delta + 4;
      hue = (hue * 60 + 360) % 360;
      const family = hue < 15 || hue >= 345 ? "wine" : hue < 65 ? "amber" : hue < 95 ? "olive"
        : hue < 170 ? "green" : hue < 195 ? "teal" : hue < 255 ? "blue" : hue < 295 ? "violet" : "rose";
      const weight = delta * (0.35 + 0.65 * high);
      weights[family] += weight;
      chromatic += weight;
    };
    if (width && height && width * height * 4 === pixels.length) {
      const centerX = (left + right) / 2, centerY = (top + bottom) / 2;
      const radiusX = Math.max((right - left) / 2 + width * 0.025, width * 0.14);
      const radiusY = Math.max((bottom - top) / 2 + height * 0.025, height * 0.085);
      const minX = Math.max(0, Math.floor(centerX - radiusX)), maxX = Math.min(width - 1, Math.ceil(centerX + radiusX));
      const minY = Math.max(0, Math.floor(centerY - radiusY)), maxY = Math.min(height - 1, Math.ceil(centerY + radiusY));
      for (let y = minY; y <= maxY; y += 3) {
        for (let x = minX; x <= maxX; x += 3) sample((y * width + x) * 4);
      }
    } else {
      for (let i = 0; i < pixels.length; i += 4) {
        if (!mask || mask[i + 3] >= 160) sample(i);
      }
    }
    const family = chromatic / Math.max(1, sampled) < 0.018 ? "neutral"
      : Object.keys(weights).reduce((best, key) => weights[key] > weights[best] ? key : best, "neutral");
    const darkCoverage = backgrounds.filter(value => value < 0.18).length / backgrounds.length;
    const lightCoverage = backgrounds.filter(value => value > 0.55).length / backgrounds.length;
    const edgeDensity = edgeChanges / Math.max(1, edgePairs);
    const mixedPattern = darkCoverage > 0.16 && lightCoverage > 0.16 && edgeDensity > 0.055;
    const accents = ["#FF70E0", "#80FFF0", "#65DECE", "#FF8197", "#71ADFF", "#C6A1F5", "#FFD06A"];
    const colors = [...new Set([...palettes[family], ...palettes.neutral, "#FFFFFF", "#171717", ...(mixedPattern ? accents : [])])];
    const results = colors.map(color => {
      const foreground = luminance(parseInt(color.slice(1, 3), 16), parseInt(color.slice(3, 5), 16), parseInt(color.slice(5, 7), 16));
      const contrasts = backgrounds.map(background => (Math.max(background, foreground) + 0.05) / (Math.min(background, foreground) + 0.05)).sort((a, b) => a - b);
      const coverage = contrasts.filter(contrast => contrast >= 3).length / contrasts.length;
      const lowContrast = contrasts[Math.floor(contrasts.length * 0.1)];
      const lab = oklab(parseInt(color.slice(1, 3), 16), parseInt(color.slice(3, 5), 16), parseInt(color.slice(5, 7), 16));
      const distances = [...regionColors.values()].map(region => ({
        distance: Math.hypot(lab[0] - region.lab[0], lab[1] - region.lab[1], lab[2] - region.lab[2]),
        chromaDistance: Math.hypot(lab[1] - region.lab[1], lab[2] - region.lab[2]),
        contrast: (Math.max(foreground, region.luminance) + 0.05) / (Math.min(foreground, region.luminance) + 0.05), count: region.count,
      })).sort((a, b) => a.distance - b.distance);
      let accumulated = 0;
      const lowSeparation = distances.find(item => (accumulated += item.count) >= backgrounds.length * 0.1).distance;
      const collision = distances.filter(item => item.distance < 0.075 || (item.contrast < 2 && item.chromaDistance < 0.085)).reduce((sum, item) => sum + item.count, 0) / backgrounds.length;
      const separationCoverage = distances.filter(item => item.distance >= 0.14).reduce((sum, item) => sum + item.count, 0) / backgrounds.length;
      const score = Math.log(lowContrast) + Math.log(contrasts[Math.floor(contrasts.length * 0.25)]) * 0.05;
      const separationScore = lowSeparation * 4 + separationCoverage + Math.log(lowContrast) * 0.3 - collision * 2;
      return {color, family, coverage, lowContrast, score, separationScore, patternScore: separationScore + coverage * 3, lowSeparation, collision, separationCoverage, mixedPattern, edgeDensity};
    });
    const bestCoverage = Math.max(...results.map(result => result.coverage));
    const readable = results.filter(result => result.coverage >= bestCoverage - 0.06);
    const clearest = readable.reduce((best, result) => result.score > best.score ? result : best);
    const eligible = readable.filter(result => result.lowContrast >= Math.min(4.5, clearest.lowContrast * 0.8));
    const preferred = palettes[family].map(color => eligible.find(result => result.color === color)).filter(Boolean);
    const distinct = mixedPattern ? results.filter(result => result.collision < 0.04 && result.lowSeparation > 0.09) : [];
    const selected = distinct.length
      ? distinct.reduce((best, result) => result.patternScore > best.patternScore ? result : best)
      : preferred[0] || eligible.find(result => palettes.neutral.includes(result.color)) || clearest;
    assessment?.push(...results.map(result => ({...result, selected: result === selected})));
    return selected.color;
  }


  function loadImage(url) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.crossOrigin = "anonymous";
      image.decoding = "async";
      image.onload = () => resolve(image);
      image.onerror = () => reject(new Error(`Failed to load image asset: ${url}`));
      image.src = url;
    });
  }

  function canvasToFile(canvas, filename) {
    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error("Failed to export your design image."));
          return;
        }

        resolve(new File([blob], filename, {type: "image/png"}));
      }, "image/png");
    });
  }

  function drawSpacedText(context, text, x, y, letterSpacing) {
    if (!letterSpacing) {
      context.fillText(text, x, y);
      return;
    }

    const characters = Array.from(text);
    const spacingAdjustment = letterSpacing * Math.max(0, characters.length - 1);
    const glyphWidth = characters.reduce(
      (total, character) => total + context.measureText(character).width,
      0,
    );
    const totalWidth = glyphWidth + spacingAdjustment;
    const originalAlign = context.textAlign;
    let cursorX = x;

    if (originalAlign === "center") {
      cursorX -= totalWidth / 2;
    } else if (originalAlign === "right") {
      cursorX -= totalWidth;
    }

    context.textAlign = "left";

    for (const character of characters) {
      context.fillText(character, cursorX, y);
      cursorX += context.measureText(character).width + letterSpacing;
    }

    context.textAlign = originalAlign;
  }

  function measureSpacedTextWidth(context, text, letterSpacing) {
    const characters = Array.from(text);
    const spacingAdjustment = letterSpacing * Math.max(0, characters.length - 1);
    return characters.reduce(
      (total, character) => total + context.measureText(character).width,
      spacingAdjustment,
    );
  }

  function slugify(value) {
    return value
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function normalizeMediaUrl(url) {
    const rawUrl = String(url || "").trim();
    if (!rawUrl || rawUrl === "null" || rawUrl === "undefined") {
      return "";
    }
    if (rawUrl.startsWith("//")) {
      return `${window.location.protocol}${rawUrl}`;
    }
    if (/^(https?:|data:|blob:)/i.test(rawUrl)) {
      return rawUrl;
    }
    if (rawUrl.startsWith("/")) {
      return new URL(rawUrl, window.location.origin).toString();
    }
    return rawUrl;
  }

  function isVisibleElement(element) {
    if (!(element instanceof Element)) {
      return false;
    }

    const styles = window.getComputedStyle(element);
    if (styles.display === "none" || styles.visibility === "hidden") {
      return false;
    }

    return element.getClientRects().length > 0;
  }

  function formatCurrency(amount) {
    const numericAmount = Number(amount);
    if (!Number.isFinite(numericAmount)) {
      return "";
    }

    const locale =
      document.documentElement.lang ||
      window.MinimogSettings?.shop_locale?.current ||
      "en-US";
    const currency = window.MinimogSettings?.currency_code || "USD";

    try {
      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
      }).format(numericAmount);
    } catch {
      return `$${numericAmount.toFixed(2)}`;
    }
  }

  function escapeSelector(value) {
    if (window.CSS?.escape) {
      return window.CSS.escape(String(value));
    }

    return String(value).replace(/["\\]/g, "\\$&");
  }

  document.querySelectorAll("[data-product-text-personalizer]").forEach((root) => {
    const personalizer = new ProductTextPersonalizer(root);
    personalizer.init();
  });
})();

